"use strict";
// tslint:disable
/**
 * Admin service API
 * An administration service for CloudLink platform.  This service allows for the management of tenants, users and services which are then provided access to CloudLink platform microservices.  The following resources are present in the management plane of CloudLink:  - **Partner** - A channel partner owns a set of *Accounts*.  - **Account** - A cloud tenant (most micro-services limit user interactions within an *Account*)  - **User** - An end user entities will use CloudLink micro-services.  - **Client** - A confidential client or service which will access resources within the *Account*  - **Site** - A physical location in which a hybrid cloud gateway is installed.  - **Gateway** - A hybrid cloud gateway which provides access to one or more premise PBX.  - **Policy** - A policy document specifies permissions to access resources.  - **Contact** - A Contact in the cloudlink admin account.
 *
 * OpenAPI spec version: 2017-09-01
 * Contact: cloudlink.support@mitel.io
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually. Blah blah blah
 */
Object.defineProperty(exports, "__esModule", { value: true });
// @ts-ignore
const URLSearchParams = require('url-search-params');
const config_1 = require("../config");
const notifications_1 = require("../notifications");
const utils_1 = require("../utils");
const service_requester_1 = require("../service-requester");
// @ts-ignore
const separators = {
    csv: ',',
    ssv: ' ',
    tsv: '\t',
    pipes: '|',
};
/**
 * AdminService
 * @class
 */
class AdminService {
    /**
     * @constructor
     */
    constructor(params = {}) {
        this.topicFocusedNotify = new notifications_1.TopicFocusedNotify({
            notify: params.notify || config_1.Config.notifications,
            topic: 'platform-api-admin',
        });
        this.serviceRequester = params.serviceRequester || new service_requester_1.ServiceRequester(Object.assign({ service: 'Admin' }, params));
    }
    notifications() {
        return this.topicFocusedNotify;
    }
    /**
    * Creates a new account.
    * @summary Create an Account
    * @param {AccountPostRequest} body
    * @throws {RequiredError}
    */
    createAccount(params) {
        // verify required parameter 'body' is not null or undefined
        if (params.body === null || params.body === undefined) {
            throw new utils_1.RequiredError('body', 'Required parameter body was null or undefined when calling createAccount.');
        }
        const path = `/accounts`;
        const headers = {};
        const query = {};
        let body = null;
        body = params.body || {};
        return this.serviceRequester.request({ method: 'POST', path, query, headers, body, options: params.options })
            .then(response => response.body);
    }
    /**
    * Creates a new tag for the account.   If tagId already exist it will overwrite.
    * @summary Create an Account Tag
    * @param {string} accountId Account ID
    * @param {TagPostRequest} body
    * @throws {RequiredError}
    */
    createAccountTag(params) {
        // verify required parameter 'accountId' is not null or undefined
        if (params.accountId === null || params.accountId === undefined) {
            throw new utils_1.RequiredError('accountId', 'Required parameter accountId was null or undefined when calling createAccountTag.');
        }
        // verify required parameter 'body' is not null or undefined
        if (params.body === null || params.body === undefined) {
            throw new utils_1.RequiredError('body', 'Required parameter body was null or undefined when calling createAccountTag.');
        }
        const path = `/accounts/{accountId}/tags`
            .replace(`{${'accountId'}}`, String(params.accountId));
        const headers = {};
        const query = {};
        let body = null;
        body = params.body || {};
        return this.serviceRequester.request({ method: 'POST', path, query, headers, body, options: params.options })
            .then(response => response.body);
    }
    /**
    * Creates a new workspace (creates a new /account) with an associated User
    * @summary Create a new Workspace (account)
    * @param {WorkspacePostRequest} body
    * @throws {RequiredError}
    */
    createWorkspace(params) {
        // verify required parameter 'body' is not null or undefined
        if (params.body === null || params.body === undefined) {
            throw new utils_1.RequiredError('body', 'Required parameter body was null or undefined when calling createWorkspace.');
        }
        const path = `/workspace`;
        const headers = {};
        const query = {};
        let body = null;
        body = params.body || {};
        return this.serviceRequester.request({ method: 'POST', path, query, headers, body, options: params.options })
            .then(response => response.body);
    }
    /**
    * Delete account with accountId.
    * @summary Delete an Account
    * @param {string} accountId Account ID
    * @param {string} [hard] use &#39;true&#39; to completely delete the given resource and associated sub-resources
    * @throws {RequiredError}
    */
    deleteAccount(params) {
        // verify required parameter 'accountId' is not null or undefined
        if (params.accountId === null || params.accountId === undefined) {
            throw new utils_1.RequiredError('accountId', 'Required parameter accountId was null or undefined when calling deleteAccount.');
        }
        const path = `/accounts/{accountId}`
            .replace(`{${'accountId'}}`, String(params.accountId));
        const headers = {};
        const query = {};
        let body = null;
        if (params.hard !== undefined) {
            query['hard'] = params.hard;
        }
        return this.serviceRequester.request({ method: 'DELETE', path, query, headers, body, options: params.options })
            .then(response => response.body);
    }
    /**
    * Delete tag with tagId of an Account with accountId   If the token has role of `USER` or `GUEST` they will not be able to modify accounts.   If the token has role of `ACCOUNT_ADMIN` they will not be able to modify other accounts.
    * @summary Delete an Account tag
    * @param {string} accountId Account ID
    * @param {string} tagId Tag ID
    * @throws {RequiredError}
    */
    deleteAccountTag(params) {
        // verify required parameter 'accountId' is not null or undefined
        if (params.accountId === null || params.accountId === undefined) {
            throw new utils_1.RequiredError('accountId', 'Required parameter accountId was null or undefined when calling deleteAccountTag.');
        }
        // verify required parameter 'tagId' is not null or undefined
        if (params.tagId === null || params.tagId === undefined) {
            throw new utils_1.RequiredError('tagId', 'Required parameter tagId was null or undefined when calling deleteAccountTag.');
        }
        const path = `/accounts/{accountId}/tags/{tagId}`
            .replace(`{${'accountId'}}`, String(params.accountId))
            .replace(`{${'tagId'}}`, String(params.tagId));
        const headers = {};
        const query = {};
        let body = null;
        return this.serviceRequester.request({ method: 'DELETE', path, query, headers, body, options: params.options })
            .then(response => response.body);
    }
    /**
    * Determine if a given Domain is associated with an existing Account.
    * @summary Check if a Domain exists
    * @param {string} domain domain
    * @throws {RequiredError}
    */
    domainExists(params) {
        // verify required parameter 'domain' is not null or undefined
        if (params.domain === null || params.domain === undefined) {
            throw new utils_1.RequiredError('domain', 'Required parameter domain was null or undefined when calling domainExists.');
        }
        const path = `/domains/{domain}`
            .replace(`{${'domain'}}`, String(params.domain));
        const headers = {};
        const query = {};
        let body = null;
        return this.serviceRequester.request({ method: 'HEAD', path, query, headers, body, options: params.options })
            .then(response => response.body);
    }
    /**
    * Retrieve account with accountId.
    * @summary Get an Account
    * @param {string} accountId Account ID
    * @param {string} [$Expand] expands an attribute
    * @throws {RequiredError}
    */
    getAccount(params) {
        // verify required parameter 'accountId' is not null or undefined
        if (params.accountId === null || params.accountId === undefined) {
            throw new utils_1.RequiredError('accountId', 'Required parameter accountId was null or undefined when calling getAccount.');
        }
        const path = `/accounts/{accountId}`
            .replace(`{${'accountId'}}`, String(params.accountId));
        const headers = {};
        const query = {};
        let body = null;
        if (params.$Expand !== undefined) {
            query['$expand'] = params.$Expand;
        }
        return this.serviceRequester.request({ method: 'GET', path, query, headers, body, options: params.options })
            .then(response => response.body);
    }
    /**
    * Retrieve tags with tagId of account with accountId
    * @summary Get an Account tag with tagId
    * @param {string} accountId Account ID
    * @param {string} tagId Tag ID
    * @throws {RequiredError}
    */
    getAccountTag(params) {
        // verify required parameter 'accountId' is not null or undefined
        if (params.accountId === null || params.accountId === undefined) {
            throw new utils_1.RequiredError('accountId', 'Required parameter accountId was null or undefined when calling getAccountTag.');
        }
        // verify required parameter 'tagId' is not null or undefined
        if (params.tagId === null || params.tagId === undefined) {
            throw new utils_1.RequiredError('tagId', 'Required parameter tagId was null or undefined when calling getAccountTag.');
        }
        const path = `/accounts/{accountId}/tags/{tagId}`
            .replace(`{${'accountId'}}`, String(params.accountId))
            .replace(`{${'tagId'}}`, String(params.tagId));
        const headers = {};
        const query = {};
        let body = null;
        return this.serviceRequester.request({ method: 'GET', path, query, headers, body, options: params.options })
            .then(response => response.body);
    }
    /**
    * Gets the tags for the account
    * @summary Get tags of account
    * @param {string} accountId Account ID
    * @throws {RequiredError}
    */
    getAccountTags(params) {
        // verify required parameter 'accountId' is not null or undefined
        if (params.accountId === null || params.accountId === undefined) {
            throw new utils_1.RequiredError('accountId', 'Required parameter accountId was null or undefined when calling getAccountTags.');
        }
        const path = `/accounts/{accountId}/tags`
            .replace(`{${'accountId'}}`, String(params.accountId));
        const headers = {};
        const query = {};
        let body = null;
        return this.serviceRequester.request({ method: 'GET', path, query, headers, body, options: params.options })
            .then(response => response.body);
    }
    /**
    * Retrieve all accounts.  Data is paged on the server and sorted by most recent partner/account first. Can only be called by GLOBAL_ADMIN or PARTNER_ADMIN roles
    * @summary Get Accounts
    * @param {string} [$Expand] expands an attribute
    * @param {number} [$Skip] Number of items to skip
    * @param {number} [$Top] Number of items to include
    * @param {string} [$SkipToken] Use skipToken for the next scroll
    * @param {string} [$Filter] Odata filter param
    * @throws {RequiredError}
    */
    getAccounts(params) {
        const path = `/accounts`;
        const headers = {};
        const query = {};
        let body = null;
        if (params.$Expand !== undefined) {
            query['$expand'] = params.$Expand;
        }
        if (params.$Skip !== undefined) {
            query['$skip'] = params.$Skip;
        }
        if (params.$Top !== undefined) {
            query['$top'] = params.$Top;
        }
        if (params.$SkipToken !== undefined) {
            query['$skipToken'] = params.$SkipToken;
        }
        if (params.$Filter !== undefined) {
            query['$filter'] = params.$Filter;
        }
        return this.serviceRequester.request({ method: 'GET', path, query, headers, body, options: params.options })
            .then(response => response.body);
    }
    /**
    * Retrieve all accounts having tags of tagId with tags expanded. Data is paged on the server and sorted by most recent partner/account first. Can only be called by GLOBAL_ADMIN or PARTNER_ADMIN roles
    * @summary Get Accounts with tags tagId expanded
    * @param {string} tagId Tag ID
    * @param {number} [$Skip] Number of items to skip
    * @param {number} [$Top] Number of items to include
    * @param {string} [$SkipToken] Use skipToken for the next scroll
    * @throws {RequiredError}
    */
    getAccountsWithTag(params) {
        // verify required parameter 'tagId' is not null or undefined
        if (params.tagId === null || params.tagId === undefined) {
            throw new utils_1.RequiredError('tagId', 'Required parameter tagId was null or undefined when calling getAccountsWithTag.');
        }
        const path = `/accounts/tags/{tagId}`
            .replace(`{${'tagId'}}`, String(params.tagId));
        const headers = {};
        const query = {};
        let body = null;
        if (params.$Skip !== undefined) {
            query['$skip'] = params.$Skip;
        }
        if (params.$Top !== undefined) {
            query['$top'] = params.$Top;
        }
        if (params.$SkipToken !== undefined) {
            query['$skipToken'] = params.$SkipToken;
        }
        return this.serviceRequester.request({ method: 'GET', path, query, headers, body, options: params.options })
            .then(response => response.body);
    }
    /**
    * Retrieve all accounts with tags expanded. Data is paged on the server and sorted by most recent partner/account first. Can only be called by GLOBAL_ADMIN or PARTNER_ADMIN roles
    * @summary Get Accounts with tags expanded
    * @param {number} [$Skip] Number of items to skip
    * @param {number} [$Top] Number of items to include
    * @param {string} [$SkipToken] Use skipToken for the next scroll
    * @throws {RequiredError}
    */
    getAccountsWithTags(params) {
        const path = `/accounts/tags`;
        const headers = {};
        const query = {};
        let body = null;
        if (params.$Skip !== undefined) {
            query['$skip'] = params.$Skip;
        }
        if (params.$Top !== undefined) {
            query['$top'] = params.$Top;
        }
        if (params.$SkipToken !== undefined) {
            query['$skipToken'] = params.$SkipToken;
        }
        return this.serviceRequester.request({ method: 'GET', path, query, headers, body, options: params.options })
            .then(response => response.body);
    }
    /**
    * Update account with accountId
    * @summary Update an Account
    * @param {string} accountId Account ID
    * @param {AccountPutRequest} body
    * @throws {RequiredError}
    */
    updateAccount(params) {
        // verify required parameter 'accountId' is not null or undefined
        if (params.accountId === null || params.accountId === undefined) {
            throw new utils_1.RequiredError('accountId', 'Required parameter accountId was null or undefined when calling updateAccount.');
        }
        // verify required parameter 'body' is not null or undefined
        if (params.body === null || params.body === undefined) {
            throw new utils_1.RequiredError('body', 'Required parameter body was null or undefined when calling updateAccount.');
        }
        const path = `/accounts/{accountId}`
            .replace(`{${'accountId'}}`, String(params.accountId));
        const headers = {};
        const query = {};
        let body = null;
        body = params.body || {};
        return this.serviceRequester.request({ method: 'PUT', path, query, headers, body, options: params.options })
            .then(response => response.body);
    }
    /**
    * Update tag with tagId of an account with accountId   If the token has role of `USER` or `GUEST` they will not be able to modify the account tag.   If the token has a role of `ACCOUNT_ADMIM` they will not be able to modify other accounts.
    * @summary Update an Account tag
    * @param {string} accountId Account ID
    * @param {string} tagId Tag ID
    * @param {TagPutRequest} body
    * @throws {RequiredError}
    */
    updateAccountTag(params) {
        // verify required parameter 'accountId' is not null or undefined
        if (params.accountId === null || params.accountId === undefined) {
            throw new utils_1.RequiredError('accountId', 'Required parameter accountId was null or undefined when calling updateAccountTag.');
        }
        // verify required parameter 'tagId' is not null or undefined
        if (params.tagId === null || params.tagId === undefined) {
            throw new utils_1.RequiredError('tagId', 'Required parameter tagId was null or undefined when calling updateAccountTag.');
        }
        // verify required parameter 'body' is not null or undefined
        if (params.body === null || params.body === undefined) {
            throw new utils_1.RequiredError('body', 'Required parameter body was null or undefined when calling updateAccountTag.');
        }
        const path = `/accounts/{accountId}/tags/{tagId}`
            .replace(`{${'accountId'}}`, String(params.accountId))
            .replace(`{${'tagId'}}`, String(params.tagId));
        const headers = {};
        const query = {};
        let body = null;
        body = params.body || {};
        return this.serviceRequester.request({ method: 'PUT', path, query, headers, body, options: params.options })
            .then(response => response.body);
    }
    /**
    * Creates a Client with the provided body parameters. The client will be created with accountId of the token provided. Only supported for roles `GLOBAL_ADMIN`, `PARTNER_ADMIN`, and `ACCOUNT_ADMIN`. Not supported for role of `USER` or `GUEST`
    * @summary Create a Client
    * @param {ClientPostRequest} body
    * @throws {RequiredError}
    */
    createClient(params) {
        // verify required parameter 'body' is not null or undefined
        if (params.body === null || params.body === undefined) {
            throw new utils_1.RequiredError('body', 'Required parameter body was null or undefined when calling createClient.');
        }
        const path = `/clients`;
        const headers = {};
        const query = {};
        let body = null;
        body = params.body || {};
        return this.serviceRequester.request({ method: 'POST', path, query, headers, body, options: params.options })
            .then(response => response.body);
    }
    /**
    * Creates a Client with the provided body parameters. Only supported for roles `GLOBAL_ADMIN`, `PARTNER_ADMIN`, and `ACCOUNT_ADMIN`. Not supported for role of `USER` or `GUEST`
    * @summary Create a Client by Account
    * @param {string} accountId Account ID
    * @param {ClientPostRequest} body
    * @throws {RequiredError}
    */
    createClientByAccountId(params) {
        // verify required parameter 'accountId' is not null or undefined
        if (params.accountId === null || params.accountId === undefined) {
            throw new utils_1.RequiredError('accountId', 'Required parameter accountId was null or undefined when calling createClientByAccountId.');
        }
        // verify required parameter 'body' is not null or undefined
        if (params.body === null || params.body === undefined) {
            throw new utils_1.RequiredError('body', 'Required parameter body was null or undefined when calling createClientByAccountId.');
        }
        const path = `/accounts/{accountId}/clients`
            .replace(`{${'accountId'}}`, String(params.accountId));
        const headers = {};
        const query = {};
        let body = null;
        body = params.body || {};
        return this.serviceRequester.request({ method: 'POST', path, query, headers, body, options: params.options })
            .then(response => response.body);
    }
    /**
    * Deletes a client by clientId. Only supported for roles `GLOBAL_ADMIN`, `PARTNER_ADMIN`, and `ACCOUNT_ADMIN`. Not supported for role of `USER` or `GUEST`.
    * @summary Delete a Client
    * @param {string} clientId Client ID
    * @throws {RequiredError}
    */
    deleteClient(params) {
        // verify required parameter 'clientId' is not null or undefined
        if (params.clientId === null || params.clientId === undefined) {
            throw new utils_1.RequiredError('clientId', 'Required parameter clientId was null or undefined when calling deleteClient.');
        }
        const path = `/clients/{clientId}`
            .replace(`{${'clientId'}}`, String(params.clientId));
        const headers = {};
        const query = {};
        let body = null;
        return this.serviceRequester.request({ method: 'DELETE', path, query, headers, body, options: params.options })
            .then(response => response.body);
    }
    /**
    * Deletes a client by clientId
    * @summary Delete a Client by Account
    * @param {string} accountId Account ID
    * @param {string} clientId Client ID
    * @throws {RequiredError}
    */
    deleteClientByAccountId(params) {
        // verify required parameter 'accountId' is not null or undefined
        if (params.accountId === null || params.accountId === undefined) {
            throw new utils_1.RequiredError('accountId', 'Required parameter accountId was null or undefined when calling deleteClientByAccountId.');
        }
        // verify required parameter 'clientId' is not null or undefined
        if (params.clientId === null || params.clientId === undefined) {
            throw new utils_1.RequiredError('clientId', 'Required parameter clientId was null or undefined when calling deleteClientByAccountId.');
        }
        const path = `/accounts/{accountId}/clients/{clientId}`
            .replace(`{${'accountId'}}`, String(params.accountId))
            .replace(`{${'clientId'}}`, String(params.clientId));
        const headers = {};
        const query = {};
        let body = null;
        return this.serviceRequester.request({ method: 'DELETE', path, query, headers, body, options: params.options })
            .then(response => response.body);
    }
    /**
    * Returns a client by id, for a client in the same account as the claims account
    * @summary Get a Client
    * @param {string} clientId Client ID
    * @throws {RequiredError}
    */
    getClient(params) {
        // verify required parameter 'clientId' is not null or undefined
        if (params.clientId === null || params.clientId === undefined) {
            throw new utils_1.RequiredError('clientId', 'Required parameter clientId was null or undefined when calling getClient.');
        }
        const path = `/clients/{clientId}`
            .replace(`{${'clientId'}}`, String(params.clientId));
        const headers = {};
        const query = {};
        let body = null;
        return this.serviceRequester.request({ method: 'GET', path, query, headers, body, options: params.options })
            .then(response => response.body);
    }
    /**
    * Returns a client by id
    * @summary Get a Client by Account
    * @param {string} accountId Account ID
    * @param {string} clientId Client ID
    * @throws {RequiredError}
    */
    getClientByAccountId(params) {
        // verify required parameter 'accountId' is not null or undefined
        if (params.accountId === null || params.accountId === undefined) {
            throw new utils_1.RequiredError('accountId', 'Required parameter accountId was null or undefined when calling getClientByAccountId.');
        }
        // verify required parameter 'clientId' is not null or undefined
        if (params.clientId === null || params.clientId === undefined) {
            throw new utils_1.RequiredError('clientId', 'Required parameter clientId was null or undefined when calling getClientByAccountId.');
        }
        const path = `/accounts/{accountId}/clients/{clientId}`
            .replace(`{${'accountId'}}`, String(params.accountId))
            .replace(`{${'clientId'}}`, String(params.clientId));
        const headers = {};
        const query = {};
        let body = null;
        return this.serviceRequester.request({ method: 'GET', path, query, headers, body, options: params.options })
            .then(response => response.body);
    }
    /**
    * Retrieve all clients if role is `GLOBAL_ADMIN`, `PARTNER_ADMIN` get all clients in the current token's partner, `ACCOUNT_ADMIN` get all clients in the current token's account. Not supported for role of `USER` or `GUEST`. Data is paged on the server and sorted by most recent clients first.
    * @summary Get Clients
    * @param {number} [$Top] Number of items to include
    * @param {number} [$Skip] Number of items to skip
    * @param {string} [$Filter] Odata filter param
    * @param {string} [$SkipToken] Use skipToken for the next scroll
    * @param {string} [skipTokenTimeout] The time (in seconds) that the result will be scrollable
    * @param {string} [$Orderby] a comma-separated list of fields and order to sort on, e.g. role asc, loginId desc.  Defaults to ascending when no order is specified.
    * @throws {RequiredError}
    */
    getClients(params) {
        const path = `/clients`;
        const headers = {};
        const query = {};
        let body = null;
        if (params.$Top !== undefined) {
            query['$top'] = params.$Top;
        }
        if (params.$Skip !== undefined) {
            query['$skip'] = params.$Skip;
        }
        if (params.$Filter !== undefined) {
            query['$filter'] = params.$Filter;
        }
        if (params.$SkipToken !== undefined) {
            query['$skipToken'] = params.$SkipToken;
        }
        if (params.skipTokenTimeout !== undefined) {
            query['skipTokenTimeout'] = params.skipTokenTimeout;
        }
        if (params.$Orderby !== undefined) {
            query['$orderby'] = params.$Orderby;
        }
        return this.serviceRequester.request({ method: 'GET', path, query, headers, body, options: params.options })
            .then(response => response.body);
    }
    /**
    * Retrieve all clients if role is `GLOBAL_ADMIN`, `PARTNER_ADMIN` get all clients in the current token's partner, `ACCOUNT_ADMIN` get all clients in the current token's account. Not supported for role `USER` or `GUEST`. Data is paged on the server and sorted by most recent clients first.
    * @summary Get Clients by Account
    * @param {string} accountId Account ID
    * @param {number} [$Top] Number of items to include
    * @param {number} [$Skip] Number of items to skip
    * @param {string} [$SkipToken] Use skipToken for the next scroll
    * @param {string} [$Filter] Odata filter param
    * @param {string} [$Orderby] a comma-separated list of fields and order to sort on, e.g. role asc, loginId desc.  Defaults to ascending when no order is specified.
    * @throws {RequiredError}
    */
    getClientsByAccountId(params) {
        // verify required parameter 'accountId' is not null or undefined
        if (params.accountId === null || params.accountId === undefined) {
            throw new utils_1.RequiredError('accountId', 'Required parameter accountId was null or undefined when calling getClientsByAccountId.');
        }
        const path = `/accounts/{accountId}/clients`
            .replace(`{${'accountId'}}`, String(params.accountId));
        const headers = {};
        const query = {};
        let body = null;
        if (params.$Top !== undefined) {
            query['$top'] = params.$Top;
        }
        if (params.$Skip !== undefined) {
            query['$skip'] = params.$Skip;
        }
        if (params.$SkipToken !== undefined) {
            query['$skipToken'] = params.$SkipToken;
        }
        if (params.$Filter !== undefined) {
            query['$filter'] = params.$Filter;
        }
        if (params.$Orderby !== undefined) {
            query['$orderby'] = params.$Orderby;
        }
        return this.serviceRequester.request({ method: 'GET', path, query, headers, body, options: params.options })
            .then(response => response.body);
    }
    /**
    * Updates a client by id
    * @summary Update a Client. Only supported for roles `GLOBAL_ADMIN`, `PARTNER_ADMIN`, and `ACCOUNT_ADMIN`. Not supported for role of `USER` or `GUEST`.
    * @param {string} clientId Client ID
    * @param {ClientPutRequest} body
    * @throws {RequiredError}
    */
    updateClient(params) {
        // verify required parameter 'clientId' is not null or undefined
        if (params.clientId === null || params.clientId === undefined) {
            throw new utils_1.RequiredError('clientId', 'Required parameter clientId was null or undefined when calling updateClient.');
        }
        // verify required parameter 'body' is not null or undefined
        if (params.body === null || params.body === undefined) {
            throw new utils_1.RequiredError('body', 'Required parameter body was null or undefined when calling updateClient.');
        }
        const path = `/clients/{clientId}`
            .replace(`{${'clientId'}}`, String(params.clientId));
        const headers = {};
        const query = {};
        let body = null;
        body = params.body || {};
        return this.serviceRequester.request({ method: 'PUT', path, query, headers, body, options: params.options })
            .then(response => response.body);
    }
    /**
    * Updates a client by id
    * @summary Update a Client by Account
    * @param {string} accountId Account ID
    * @param {string} clientId Client ID
    * @param {ClientPutRequest} body
    * @throws {RequiredError}
    */
    updateClientByAccountId(params) {
        // verify required parameter 'accountId' is not null or undefined
        if (params.accountId === null || params.accountId === undefined) {
            throw new utils_1.RequiredError('accountId', 'Required parameter accountId was null or undefined when calling updateClientByAccountId.');
        }
        // verify required parameter 'clientId' is not null or undefined
        if (params.clientId === null || params.clientId === undefined) {
            throw new utils_1.RequiredError('clientId', 'Required parameter clientId was null or undefined when calling updateClientByAccountId.');
        }
        // verify required parameter 'body' is not null or undefined
        if (params.body === null || params.body === undefined) {
            throw new utils_1.RequiredError('body', 'Required parameter body was null or undefined when calling updateClientByAccountId.');
        }
        const path = `/accounts/{accountId}/clients/{clientId}`
            .replace(`{${'accountId'}}`, String(params.accountId))
            .replace(`{${'clientId'}}`, String(params.clientId));
        const headers = {};
        const query = {};
        let body = null;
        body = params.body || {};
        return this.serviceRequester.request({ method: 'PUT', path, query, headers, body, options: params.options })
            .then(response => response.body);
    }
    /**
    * Creates one or more new contacts in the callers account. TECHNICAL_SUPPORT, ON_SITE, MAINTAINER, and MAIN_CONTACT are for ACCOUNT_ADMIN or higher. TEMPORARY contacts have a limited lifetime. PERSONAL_CONTACTS are accessible only for the user/client that created the contact. contactDetails are only available for CORPORATE, PBX and PERSONAL_CONTACT types.
    * @summary Create one or more contacts by Account
    * @param {string} accountId Account ID
    * @param {ContactPostRequest} body
    * @throws {RequiredError}
    */
    createAccountContacts(params) {
        // verify required parameter 'accountId' is not null or undefined
        if (params.accountId === null || params.accountId === undefined) {
            throw new utils_1.RequiredError('accountId', 'Required parameter accountId was null or undefined when calling createAccountContacts.');
        }
        // verify required parameter 'body' is not null or undefined
        if (params.body === null || params.body === undefined) {
            throw new utils_1.RequiredError('body', 'Required parameter body was null or undefined when calling createAccountContacts.');
        }
        const path = `/accounts/{accountId}/contacts`
            .replace(`{${'accountId'}}`, String(params.accountId));
        const headers = {};
        const query = {};
        let body = null;
        body = params.body || {};
        return this.serviceRequester.request({ method: 'POST', path, query, headers, body, options: params.options })
            .then(response => response.body);
    }
    /**
    * Creates one or more new contacts in the callers account. TECHNICAL_SUPPORT, ON_SITE, MAINTAINER, and MAIN_CONTACT are for ACCOUNT_ADMIN or higher. TEMPORARY contacts have a limited lifetime. PERSONAL_CONTACTS are accessible only for the user/client that created the contact. contactDetails are only available for CORPORATE, PBX and PERSONAL_CONTACT types.
    * @summary Create one or more contacts
    * @param {ContactPostRequest} body
    * @throws {RequiredError}
    */
    createContacts(params) {
        // verify required parameter 'body' is not null or undefined
        if (params.body === null || params.body === undefined) {
            throw new utils_1.RequiredError('body', 'Required parameter body was null or undefined when calling createContacts.');
        }
        const path = `/contacts`;
        const headers = {};
        const query = {};
        let body = null;
        body = params.body || {};
        return this.serviceRequester.request({ method: 'POST', path, query, headers, body, options: params.options })
            .then(response => response.body);
    }
    /**
    * Delete contact with contactId of an Account with accountId
    * @summary Delete an Account contact
    * @param {string} accountId Account ID
    * @param {string} contactId Contact ID
    * @throws {RequiredError}
    */
    deleteAccountContact(params) {
        // verify required parameter 'accountId' is not null or undefined
        if (params.accountId === null || params.accountId === undefined) {
            throw new utils_1.RequiredError('accountId', 'Required parameter accountId was null or undefined when calling deleteAccountContact.');
        }
        // verify required parameter 'contactId' is not null or undefined
        if (params.contactId === null || params.contactId === undefined) {
            throw new utils_1.RequiredError('contactId', 'Required parameter contactId was null or undefined when calling deleteAccountContact.');
        }
        const path = `/accounts/{accountId}/contacts/{contactId}`
            .replace(`{${'accountId'}}`, String(params.accountId))
            .replace(`{${'contactId'}}`, String(params.contactId));
        const headers = {};
        const query = {};
        let body = null;
        return this.serviceRequester.request({ method: 'DELETE', path, query, headers, body, options: params.options })
            .then(response => response.body);
    }
    /**
    * Delete contact with contactId
    * @summary Delete a contact
    * @param {string} contactId Contact ID
    * @throws {RequiredError}
    */
    deleteContact(params) {
        // verify required parameter 'contactId' is not null or undefined
        if (params.contactId === null || params.contactId === undefined) {
            throw new utils_1.RequiredError('contactId', 'Required parameter contactId was null or undefined when calling deleteContact.');
        }
        const path = `/contacts/{contactId}`
            .replace(`{${'contactId'}}`, String(params.contactId));
        const headers = {};
        const query = {};
        let body = null;
        return this.serviceRequester.request({ method: 'DELETE', path, query, headers, body, options: params.options })
            .then(response => response.body);
    }
    /**
    * Retrieve contact with contactId of account with accountId
    * @summary Get an Account contact with contactId
    * @param {string} accountId Account ID
    * @param {string} contactId Contact ID
    * @throws {RequiredError}
    */
    getAccountContact(params) {
        // verify required parameter 'accountId' is not null or undefined
        if (params.accountId === null || params.accountId === undefined) {
            throw new utils_1.RequiredError('accountId', 'Required parameter accountId was null or undefined when calling getAccountContact.');
        }
        // verify required parameter 'contactId' is not null or undefined
        if (params.contactId === null || params.contactId === undefined) {
            throw new utils_1.RequiredError('contactId', 'Required parameter contactId was null or undefined when calling getAccountContact.');
        }
        const path = `/accounts/{accountId}/contacts/{contactId}`
            .replace(`{${'accountId'}}`, String(params.accountId))
            .replace(`{${'contactId'}}`, String(params.contactId));
        const headers = {};
        const query = {};
        let body = null;
        return this.serviceRequester.request({ method: 'GET', path, query, headers, body, options: params.options })
            .then(response => response.body);
    }
    /**
    * Gets the contacts for the account. A USER can retrieve only the CORPORATE, PBX contact types plus the PERSONAL_CONTACTS that they created, an ACCOUNT_ADMIN or higher can retrieve all the types but only the PERSONAL_CONTACTS that they created.
    * @summary Get contacts of account
    * @param {string} accountId Account ID
    * @param {number} [$Skip] Number of items to skip
    * @param {number} [$Top] Number of items to include
    * @param {string} [$SkipToken] Use skipToken for the next scroll
    * @param {string} [$Filter] Odata filter param
    * @param {string} [$Search] text based search
    * @param {string} [$SearchKeys] a comma-separated list of keys to search in, e.g. name, email, tags. Used in conjunction with $search.
    * @param {string} [items] a comma-separated list of items to get, e.g. user-id-1, user-id-2
    * @param {string} [itemKeys] a comma-separated list of keys to lookup matching items in, e.g. userId, loginId, used in conjunction with items
    * @throws {RequiredError}
    */
    getAccountContacts(params) {
        // verify required parameter 'accountId' is not null or undefined
        if (params.accountId === null || params.accountId === undefined) {
            throw new utils_1.RequiredError('accountId', 'Required parameter accountId was null or undefined when calling getAccountContacts.');
        }
        const path = `/accounts/{accountId}/contacts`
            .replace(`{${'accountId'}}`, String(params.accountId));
        const headers = {};
        const query = {};
        let body = null;
        if (params.$Skip !== undefined) {
            query['$skip'] = params.$Skip;
        }
        if (params.$Top !== undefined) {
            query['$top'] = params.$Top;
        }
        if (params.$SkipToken !== undefined) {
            query['$skipToken'] = params.$SkipToken;
        }
        if (params.$Filter !== undefined) {
            query['$filter'] = params.$Filter;
        }
        if (params.$Search !== undefined) {
            query['$search'] = params.$Search;
        }
        if (params.$SearchKeys !== undefined) {
            query['$searchKeys'] = params.$SearchKeys;
        }
        if (params.items !== undefined) {
            query['items'] = params.items;
        }
        if (params.itemKeys !== undefined) {
            query['itemKeys'] = params.itemKeys;
        }
        return this.serviceRequester.request({ method: 'GET', path, query, headers, body, options: params.options })
            .then(response => response.body);
    }
    /**
    * Retrieve contact
    * @summary Get contact by contactId
    * @param {string} contactId Contact ID
    * @throws {RequiredError}
    */
    getContact(params) {
        // verify required parameter 'contactId' is not null or undefined
        if (params.contactId === null || params.contactId === undefined) {
            throw new utils_1.RequiredError('contactId', 'Required parameter contactId was null or undefined when calling getContact.');
        }
        const path = `/contacts/{contactId}`
            .replace(`{${'contactId'}}`, String(params.contactId));
        const headers = {};
        const query = {};
        let body = null;
        return this.serviceRequester.request({ method: 'GET', path, query, headers, body, options: params.options })
            .then(response => response.body);
    }
    /**
    * Gets the contacts for the account of the caller. A USER can retrieve only the CORPORATE, PBX contact types plus the PERSONAL_CONTACTS that they created, an ACCOUNT_ADMIN or higher can retrieve all the types but only the PERSONAL_CONTACTS that they created.
    * @summary Get contacts
    * @param {number} [$Skip] Number of items to skip
    * @param {number} [$Top] Number of items to include
    * @param {string} [$SkipToken] Use skipToken for the next scroll
    * @param {string} [$Filter] Odata filter param
    * @param {string} [$Search] text based search
    * @param {string} [$SearchKeys] a comma-separated list of keys to search in, e.g. name, email, tags. Used in conjunction with $search.
    * @param {string} [items] a comma-separated list of items to get, e.g. user-id-1, user-id-2
    * @param {string} [itemKeys] a comma-separated list of keys to lookup matching items in, e.g. userId, loginId, used in conjunction with items
    * @throws {RequiredError}
    */
    getContacts(params) {
        const path = `/contacts`;
        const headers = {};
        const query = {};
        let body = null;
        if (params.$Skip !== undefined) {
            query['$skip'] = params.$Skip;
        }
        if (params.$Top !== undefined) {
            query['$top'] = params.$Top;
        }
        if (params.$SkipToken !== undefined) {
            query['$skipToken'] = params.$SkipToken;
        }
        if (params.$Filter !== undefined) {
            query['$filter'] = params.$Filter;
        }
        if (params.$Search !== undefined) {
            query['$search'] = params.$Search;
        }
        if (params.$SearchKeys !== undefined) {
            query['$searchKeys'] = params.$SearchKeys;
        }
        if (params.items !== undefined) {
            query['items'] = params.items;
        }
        if (params.itemKeys !== undefined) {
            query['itemKeys'] = params.itemKeys;
        }
        return this.serviceRequester.request({ method: 'GET', path, query, headers, body, options: params.options })
            .then(response => response.body);
    }
    /**
    * Batch of operations to create, update, delete multiple contacts in one request
    * @summary Patch contacts
    * @param {PatchRequest} body
    * @throws {RequiredError}
    */
    patchContacts(params) {
        // verify required parameter 'body' is not null or undefined
        if (params.body === null || params.body === undefined) {
            throw new utils_1.RequiredError('body', 'Required parameter body was null or undefined when calling patchContacts.');
        }
        const path = `/contacts`;
        const headers = {};
        const query = {};
        let body = null;
        body = params.body || {};
        return this.serviceRequester.request({ method: 'PATCH', path, query, headers, body, options: params.options })
            .then(response => response.body);
    }
    /**
    * Batch of operations to create, update, delete multiple contacts in one request
    * @summary Patch contacts
    * @param {PatchRequest} body
    * @throws {RequiredError}
    */
    patchContactsByAccount(params) {
        // verify required parameter 'body' is not null or undefined
        if (params.body === null || params.body === undefined) {
            throw new utils_1.RequiredError('body', 'Required parameter body was null or undefined when calling patchContactsByAccount.');
        }
        const path = `/accounts/{accountId}/contacts`;
        const headers = {};
        const query = {};
        let body = null;
        body = params.body || {};
        return this.serviceRequester.request({ method: 'PATCH', path, query, headers, body, options: params.options })
            .then(response => response.body);
    }
    /**
    * Update contact with contactId of an account with accountId
    * @summary Update an Account contact
    * @param {string} accountId Account ID
    * @param {string} contactId Contact ID
    * @param {ContactPutRequest} body
    * @throws {RequiredError}
    */
    updateAccountContact(params) {
        // verify required parameter 'accountId' is not null or undefined
        if (params.accountId === null || params.accountId === undefined) {
            throw new utils_1.RequiredError('accountId', 'Required parameter accountId was null or undefined when calling updateAccountContact.');
        }
        // verify required parameter 'contactId' is not null or undefined
        if (params.contactId === null || params.contactId === undefined) {
            throw new utils_1.RequiredError('contactId', 'Required parameter contactId was null or undefined when calling updateAccountContact.');
        }
        // verify required parameter 'body' is not null or undefined
        if (params.body === null || params.body === undefined) {
            throw new utils_1.RequiredError('body', 'Required parameter body was null or undefined when calling updateAccountContact.');
        }
        const path = `/accounts/{accountId}/contacts/{contactId}`
            .replace(`{${'accountId'}}`, String(params.accountId))
            .replace(`{${'contactId'}}`, String(params.contactId));
        const headers = {};
        const query = {};
        let body = null;
        body = params.body || {};
        return this.serviceRequester.request({ method: 'PUT', path, query, headers, body, options: params.options })
            .then(response => response.body);
    }
    /**
    * Update contact with contactId
    * @summary Update an contact
    * @param {string} contactId Contact ID
    * @param {ContactPutRequest} body
    * @throws {RequiredError}
    */
    updateContact(params) {
        // verify required parameter 'contactId' is not null or undefined
        if (params.contactId === null || params.contactId === undefined) {
            throw new utils_1.RequiredError('contactId', 'Required parameter contactId was null or undefined when calling updateContact.');
        }
        // verify required parameter 'body' is not null or undefined
        if (params.body === null || params.body === undefined) {
            throw new utils_1.RequiredError('body', 'Required parameter body was null or undefined when calling updateContact.');
        }
        const path = `/contacts/{contactId}`
            .replace(`{${'contactId'}}`, String(params.contactId));
        const headers = {};
        const query = {};
        let body = null;
        body = params.body || {};
        return this.serviceRequester.request({ method: 'PUT', path, query, headers, body, options: params.options })
            .then(response => response.body);
    }
    /**
    * Sends an email based on the given template.
    * @summary Sends a templated email
    * @param {string} templateId Email Template ID
    * @param {EmailTemplateRequest} body
    * @throws {RequiredError}
    */
    sendTemplatedEmail(params) {
        // verify required parameter 'templateId' is not null or undefined
        if (params.templateId === null || params.templateId === undefined) {
            throw new utils_1.RequiredError('templateId', 'Required parameter templateId was null or undefined when calling sendTemplatedEmail.');
        }
        // verify required parameter 'body' is not null or undefined
        if (params.body === null || params.body === undefined) {
            throw new utils_1.RequiredError('body', 'Required parameter body was null or undefined when calling sendTemplatedEmail.');
        }
        const path = `/emails/templates/{templateId}`
            .replace(`{${'templateId'}}`, String(params.templateId));
        const headers = {};
        const query = {};
        let body = null;
        body = params.body || {};
        return this.serviceRequester.request({ method: 'POST', path, query, headers, body, options: params.options })
            .then(response => response.body);
    }
    /**
    * Retrieve aggregate results of users, contacts, groups, and clients in the account of the token. Data is paged on the server and sorted entityType first.
    * @summary Get aggregate of users, contacts, groups, and clients
    * @param {number} [$Top] Number of items to include
    * @param {number} [$Skip] Number of items to skip
    * @param {string} [$SkipToken] Use skipToken for the next scroll
    * @param {string} [$Filter] Odata filter param
    * @param {string} [$Search] text based search
    * @param {string} [$SearchKeys] a comma-separated list of keys to search in, e.g. name, email, tags. Used in conjunction with $search.
    * @param {string} [items] a comma-separated list of items to get, e.g. user-id-1, user-id-2
    * @param {string} [itemKeys] a comma-separated list of keys to lookup matching items in, e.g. userId, loginId, used in conjunction with items
    * @param {string} [$Orderby] a comma-separated list of fields and order to sort on, e.g. role asc, loginId desc.  Defaults to ascending when no order is specified.
    * @throws {RequiredError}
    */
    getEntities(params) {
        const path = `/entities`;
        const headers = {};
        const query = {};
        let body = null;
        if (params.$Top !== undefined) {
            query['$top'] = params.$Top;
        }
        if (params.$Skip !== undefined) {
            query['$skip'] = params.$Skip;
        }
        if (params.$SkipToken !== undefined) {
            query['$skipToken'] = params.$SkipToken;
        }
        if (params.$Filter !== undefined) {
            query['$filter'] = params.$Filter;
        }
        if (params.$Search !== undefined) {
            query['$search'] = params.$Search;
        }
        if (params.$SearchKeys !== undefined) {
            query['$searchKeys'] = params.$SearchKeys;
        }
        if (params.items !== undefined) {
            query['items'] = params.items;
        }
        if (params.itemKeys !== undefined) {
            query['itemKeys'] = params.itemKeys;
        }
        if (params.$Orderby !== undefined) {
            query['$orderby'] = params.$Orderby;
        }
        return this.serviceRequester.request({ method: 'GET', path, query, headers, body, options: params.options })
            .then(response => response.body);
    }
    /**
    * Retrieve aggregate results of users, contacts, groups and clients in account. `GLOBAL_ADMIN` will get users, contacts, groups and clients in any accounts provided in the route. `PARTNER_ADMIN` will get users, contacts, groups and clients in any accounts provided in the route within the partner. `ACCOUNT_ADMIN`, `USER` and `GUEST` will get users, contacts, groups and clients within the account of the token. Data is paged on the server and sorted entityType first.
    * @summary Get aggregate of users, contacts, groups and clients in the account provided.
    * @param {string} accountId Account ID
    * @param {number} [$Top] Number of items to include
    * @param {number} [$Skip] Number of items to skip
    * @param {string} [$SkipToken] Use skipToken for the next scroll
    * @param {string} [$Filter] Odata filter param
    * @param {string} [$Search] text based search
    * @param {string} [$SearchKeys] a comma-separated list of keys to search in, e.g. name, email, tags. Used in conjunction with $search.
    * @param {string} [items] a comma-separated list of items to get, e.g. user-id-1, user-id-2
    * @param {string} [itemKeys] a comma-separated list of keys to lookup matching items in, e.g. userId, loginId, used in conjunction with items
    * @param {string} [$Orderby] a comma-separated list of fields and order to sort on, e.g. role asc, loginId desc.  Defaults to ascending when no order is specified.
    * @throws {RequiredError}
    */
    getEntitiesByAccountId(params) {
        // verify required parameter 'accountId' is not null or undefined
        if (params.accountId === null || params.accountId === undefined) {
            throw new utils_1.RequiredError('accountId', 'Required parameter accountId was null or undefined when calling getEntitiesByAccountId.');
        }
        const path = `/accounts/{accountId}/entities`
            .replace(`{${'accountId'}}`, String(params.accountId));
        const headers = {};
        const query = {};
        let body = null;
        if (params.$Top !== undefined) {
            query['$top'] = params.$Top;
        }
        if (params.$Skip !== undefined) {
            query['$skip'] = params.$Skip;
        }
        if (params.$SkipToken !== undefined) {
            query['$skipToken'] = params.$SkipToken;
        }
        if (params.$Filter !== undefined) {
            query['$filter'] = params.$Filter;
        }
        if (params.$Search !== undefined) {
            query['$search'] = params.$Search;
        }
        if (params.$SearchKeys !== undefined) {
            query['$searchKeys'] = params.$SearchKeys;
        }
        if (params.items !== undefined) {
            query['items'] = params.items;
        }
        if (params.itemKeys !== undefined) {
            query['itemKeys'] = params.itemKeys;
        }
        if (params.$Orderby !== undefined) {
            query['$orderby'] = params.$Orderby;
        }
        return this.serviceRequester.request({ method: 'GET', path, query, headers, body, options: params.options })
            .then(response => response.body);
    }
    /**
    * Retrieve user, contact, group, or client with entityId(userId, contactId, groupId, clientId) if the entity is in the tokens account.
    * @summary Get a user, contact, group, or client
    * @param {string} entityId Entities ID
    * @throws {RequiredError}
    */
    getEntitiesById(params) {
        // verify required parameter 'entityId' is not null or undefined
        if (params.entityId === null || params.entityId === undefined) {
            throw new utils_1.RequiredError('entityId', 'Required parameter entityId was null or undefined when calling getEntitiesById.');
        }
        const path = `/entities/{entityId}`
            .replace(`{${'entityId'}}`, String(params.entityId));
        const headers = {};
        const query = {};
        let body = null;
        return this.serviceRequester.request({ method: 'GET', path, query, headers, body, options: params.options })
            .then(response => response.body);
    }
    /**
    * Retrieve user, contact, group or client with entityId(userId, contactId, groupId, clientId) in account provided in the route. `GLOBAL_ADMIN` will get a user, contact, group and client by entityId in any accounts provided in the route. `PARTNER_ADMIN` will get a user, contact, group, or client by entityId in any accounts provided in the route within the partner. `ACCOUNT_ADMIN`, `USER` and `GUEST` will get users, contacts, groups and clients by entityId within the account of the token.
    * @summary Get a user, contact, group or client
    * @param {string} accountId Account ID
    * @param {string} entityId Entities ID
    * @throws {RequiredError}
    */
    getEntitiesByIdByAccountId(params) {
        // verify required parameter 'accountId' is not null or undefined
        if (params.accountId === null || params.accountId === undefined) {
            throw new utils_1.RequiredError('accountId', 'Required parameter accountId was null or undefined when calling getEntitiesByIdByAccountId.');
        }
        // verify required parameter 'entityId' is not null or undefined
        if (params.entityId === null || params.entityId === undefined) {
            throw new utils_1.RequiredError('entityId', 'Required parameter entityId was null or undefined when calling getEntitiesByIdByAccountId.');
        }
        const path = `/accounts/{accountId}/entities/{entityId}`
            .replace(`{${'accountId'}}`, String(params.accountId))
            .replace(`{${'entityId'}}`, String(params.entityId));
        const headers = {};
        const query = {};
        let body = null;
        return this.serviceRequester.request({ method: 'GET', path, query, headers, body, options: params.options })
            .then(response => response.body);
    }
    /**
    * Creates a Group with the provided body parameters. The group will be created with accountId of the token provided.
    * @summary Create a Group
    * @param {GroupPostRequest} body
    * @throws {RequiredError}
    */
    createGroup(params) {
        // verify required parameter 'body' is not null or undefined
        if (params.body === null || params.body === undefined) {
            throw new utils_1.RequiredError('body', 'Required parameter body was null or undefined when calling createGroup.');
        }
        const path = `/groups`;
        const headers = {};
        const query = {};
        let body = null;
        body = params.body || {};
        return this.serviceRequester.request({ method: 'POST', path, query, headers, body, options: params.options })
            .then(response => response.body);
    }
    /**
    * Creates a Group with the provided body parameters. The group will be created with accountId in the path.
    * @summary Create a Group by Account
    * @param {string} accountId Account ID
    * @param {GroupPostRequest} body
    * @throws {RequiredError}
    */
    createGroupByAccountId(params) {
        // verify required parameter 'accountId' is not null or undefined
        if (params.accountId === null || params.accountId === undefined) {
            throw new utils_1.RequiredError('accountId', 'Required parameter accountId was null or undefined when calling createGroupByAccountId.');
        }
        // verify required parameter 'body' is not null or undefined
        if (params.body === null || params.body === undefined) {
            throw new utils_1.RequiredError('body', 'Required parameter body was null or undefined when calling createGroupByAccountId.');
        }
        const path = `/accounts/{accountId}/groups`
            .replace(`{${'accountId'}}`, String(params.accountId));
        const headers = {};
        const query = {};
        let body = null;
        body = params.body || {};
        return this.serviceRequester.request({ method: 'POST', path, query, headers, body, options: params.options })
            .then(response => response.body);
    }
    /**
    * Creates a new tag for the group.   If tagId already exist it will overwrite.
    * @summary Create a Group Tag
    * @param {string} groupId GroupId
    * @param {TagPostRequest} body
    * @throws {RequiredError}
    */
    createGroupTag(params) {
        // verify required parameter 'groupId' is not null or undefined
        if (params.groupId === null || params.groupId === undefined) {
            throw new utils_1.RequiredError('groupId', 'Required parameter groupId was null or undefined when calling createGroupTag.');
        }
        // verify required parameter 'body' is not null or undefined
        if (params.body === null || params.body === undefined) {
            throw new utils_1.RequiredError('body', 'Required parameter body was null or undefined when calling createGroupTag.');
        }
        const path = `/groups/{groupId}/tags`
            .replace(`{${'groupId'}}`, String(params.groupId));
        const headers = {};
        const query = {};
        let body = null;
        body = params.body || {};
        return this.serviceRequester.request({ method: 'POST', path, query, headers, body, options: params.options })
            .then(response => response.body);
    }
    /**
    * Creates a new tag for the group.   If tagId already exist it will overwrite.
    * @summary Create a Group tag by Account
    * @param {string} accountId Account ID
    * @param {string} groupId GroupId
    * @param {TagPostRequest} body
    * @throws {RequiredError}
    */
    createGroupTagByAccountId(params) {
        // verify required parameter 'accountId' is not null or undefined
        if (params.accountId === null || params.accountId === undefined) {
            throw new utils_1.RequiredError('accountId', 'Required parameter accountId was null or undefined when calling createGroupTagByAccountId.');
        }
        // verify required parameter 'groupId' is not null or undefined
        if (params.groupId === null || params.groupId === undefined) {
            throw new utils_1.RequiredError('groupId', 'Required parameter groupId was null or undefined when calling createGroupTagByAccountId.');
        }
        // verify required parameter 'body' is not null or undefined
        if (params.body === null || params.body === undefined) {
            throw new utils_1.RequiredError('body', 'Required parameter body was null or undefined when calling createGroupTagByAccountId.');
        }
        const path = `/accounts/{accountId}/groups/{groupId}/tags`
            .replace(`{${'accountId'}}`, String(params.accountId))
            .replace(`{${'groupId'}}`, String(params.groupId));
        const headers = {};
        const query = {};
        let body = null;
        body = params.body || {};
        return this.serviceRequester.request({ method: 'POST', path, query, headers, body, options: params.options })
            .then(response => response.body);
    }
    /**
    * Deletes a group by Id
    * @summary Delete a Group
    * @param {string} groupId GroupId
    * @throws {RequiredError}
    */
    deleteGroup(params) {
        // verify required parameter 'groupId' is not null or undefined
        if (params.groupId === null || params.groupId === undefined) {
            throw new utils_1.RequiredError('groupId', 'Required parameter groupId was null or undefined when calling deleteGroup.');
        }
        const path = `/groups/{groupId}`
            .replace(`{${'groupId'}}`, String(params.groupId));
        const headers = {};
        const query = {};
        let body = null;
        return this.serviceRequester.request({ method: 'DELETE', path, query, headers, body, options: params.options })
            .then(response => response.body);
    }
    /**
    * Deletes a group by Id
    * @summary Delete a Group by Account
    * @param {string} accountId Account ID
    * @param {string} groupId GroupId
    * @throws {RequiredError}
    */
    deleteGroupByAccountId(params) {
        // verify required parameter 'accountId' is not null or undefined
        if (params.accountId === null || params.accountId === undefined) {
            throw new utils_1.RequiredError('accountId', 'Required parameter accountId was null or undefined when calling deleteGroupByAccountId.');
        }
        // verify required parameter 'groupId' is not null or undefined
        if (params.groupId === null || params.groupId === undefined) {
            throw new utils_1.RequiredError('groupId', 'Required parameter groupId was null or undefined when calling deleteGroupByAccountId.');
        }
        const path = `/accounts/{accountId}/groups/{groupId}`
            .replace(`{${'accountId'}}`, String(params.accountId))
            .replace(`{${'groupId'}}`, String(params.groupId));
        const headers = {};
        const query = {};
        let body = null;
        return this.serviceRequester.request({ method: 'DELETE', path, query, headers, body, options: params.options })
            .then(response => response.body);
    }
    /**
    * Delete tag with tagId of a group with groupId.
    * @summary Delete a Group tag
    * @param {string} groupId GroupId
    * @param {string} tagId Tag ID
    * @throws {RequiredError}
    */
    deleteGroupTag(params) {
        // verify required parameter 'groupId' is not null or undefined
        if (params.groupId === null || params.groupId === undefined) {
            throw new utils_1.RequiredError('groupId', 'Required parameter groupId was null or undefined when calling deleteGroupTag.');
        }
        // verify required parameter 'tagId' is not null or undefined
        if (params.tagId === null || params.tagId === undefined) {
            throw new utils_1.RequiredError('tagId', 'Required parameter tagId was null or undefined when calling deleteGroupTag.');
        }
        const path = `/groups/{groupId}/tags/{tagId}`
            .replace(`{${'groupId'}}`, String(params.groupId))
            .replace(`{${'tagId'}}`, String(params.tagId));
        const headers = {};
        const query = {};
        let body = null;
        return this.serviceRequester.request({ method: 'DELETE', path, query, headers, body, options: params.options })
            .then(response => response.body);
    }
    /**
    * Delete tag with tagId of a group with groupId.
    * @summary Delete a Group tag by Account
    * @param {string} accountId Account ID
    * @param {string} groupId GroupId
    * @param {string} tagId Tag ID
    * @throws {RequiredError}
    */
    deleteGroupTagByAccountId(params) {
        // verify required parameter 'accountId' is not null or undefined
        if (params.accountId === null || params.accountId === undefined) {
            throw new utils_1.RequiredError('accountId', 'Required parameter accountId was null or undefined when calling deleteGroupTagByAccountId.');
        }
        // verify required parameter 'groupId' is not null or undefined
        if (params.groupId === null || params.groupId === undefined) {
            throw new utils_1.RequiredError('groupId', 'Required parameter groupId was null or undefined when calling deleteGroupTagByAccountId.');
        }
        // verify required parameter 'tagId' is not null or undefined
        if (params.tagId === null || params.tagId === undefined) {
            throw new utils_1.RequiredError('tagId', 'Required parameter tagId was null or undefined when calling deleteGroupTagByAccountId.');
        }
        const path = `/accounts/{accountId}/groups/{groupId}/tags/{tagId}`
            .replace(`{${'accountId'}}`, String(params.accountId))
            .replace(`{${'groupId'}}`, String(params.groupId))
            .replace(`{${'tagId'}}`, String(params.tagId));
        const headers = {};
        const query = {};
        let body = null;
        return this.serviceRequester.request({ method: 'DELETE', path, query, headers, body, options: params.options })
            .then(response => response.body);
    }
    /**
    * Returns a group by id
    * @summary Get a Group
    * @param {string} groupId GroupId
    * @throws {RequiredError}
    */
    getGroup(params) {
        // verify required parameter 'groupId' is not null or undefined
        if (params.groupId === null || params.groupId === undefined) {
            throw new utils_1.RequiredError('groupId', 'Required parameter groupId was null or undefined when calling getGroup.');
        }
        const path = `/groups/{groupId}`
            .replace(`{${'groupId'}}`, String(params.groupId));
        const headers = {};
        const query = {};
        let body = null;
        return this.serviceRequester.request({ method: 'GET', path, query, headers, body, options: params.options })
            .then(response => response.body);
    }
    /**
    * Returns a group by id
    * @summary Get a Group by Account
    * @param {string} accountId Account ID
    * @param {string} groupId GroupId
    * @throws {RequiredError}
    */
    getGroupByAccountId(params) {
        // verify required parameter 'accountId' is not null or undefined
        if (params.accountId === null || params.accountId === undefined) {
            throw new utils_1.RequiredError('accountId', 'Required parameter accountId was null or undefined when calling getGroupByAccountId.');
        }
        // verify required parameter 'groupId' is not null or undefined
        if (params.groupId === null || params.groupId === undefined) {
            throw new utils_1.RequiredError('groupId', 'Required parameter groupId was null or undefined when calling getGroupByAccountId.');
        }
        const path = `/accounts/{accountId}/groups/{groupId}`
            .replace(`{${'accountId'}}`, String(params.accountId))
            .replace(`{${'groupId'}}`, String(params.groupId));
        const headers = {};
        const query = {};
        let body = null;
        return this.serviceRequester.request({ method: 'GET', path, query, headers, body, options: params.options })
            .then(response => response.body);
    }
    /**
    * Returns a group by id
    * @summary Get a Group Member
    * @param {string} groupId GroupId
    * @param {string} memberId Member ID
    * @throws {RequiredError}
    */
    getGroupMember(params) {
        // verify required parameter 'groupId' is not null or undefined
        if (params.groupId === null || params.groupId === undefined) {
            throw new utils_1.RequiredError('groupId', 'Required parameter groupId was null or undefined when calling getGroupMember.');
        }
        // verify required parameter 'memberId' is not null or undefined
        if (params.memberId === null || params.memberId === undefined) {
            throw new utils_1.RequiredError('memberId', 'Required parameter memberId was null or undefined when calling getGroupMember.');
        }
        const path = `/groups/{groupId}/members/{memberId}`
            .replace(`{${'groupId'}}`, String(params.groupId))
            .replace(`{${'memberId'}}`, String(params.memberId));
        const headers = {};
        const query = {};
        let body = null;
        return this.serviceRequester.request({ method: 'GET', path, query, headers, body, options: params.options })
            .then(response => response.body);
    }
    /**
    * Returns a member by id
    * @summary Get a Group Member by Account
    * @param {string} accountId Account ID
    * @param {string} groupId GroupId
    * @param {string} memberId Member ID
    * @throws {RequiredError}
    */
    getGroupMemberByAccountId(params) {
        // verify required parameter 'accountId' is not null or undefined
        if (params.accountId === null || params.accountId === undefined) {
            throw new utils_1.RequiredError('accountId', 'Required parameter accountId was null or undefined when calling getGroupMemberByAccountId.');
        }
        // verify required parameter 'groupId' is not null or undefined
        if (params.groupId === null || params.groupId === undefined) {
            throw new utils_1.RequiredError('groupId', 'Required parameter groupId was null or undefined when calling getGroupMemberByAccountId.');
        }
        // verify required parameter 'memberId' is not null or undefined
        if (params.memberId === null || params.memberId === undefined) {
            throw new utils_1.RequiredError('memberId', 'Required parameter memberId was null or undefined when calling getGroupMemberByAccountId.');
        }
        const path = `/accounts/{accountId}/groups/{groupId}/members/{memberId}`
            .replace(`{${'accountId'}}`, String(params.accountId))
            .replace(`{${'groupId'}}`, String(params.groupId))
            .replace(`{${'memberId'}}`, String(params.memberId));
        const headers = {};
        const query = {};
        let body = null;
        return this.serviceRequester.request({ method: 'GET', path, query, headers, body, options: params.options })
            .then(response => response.body);
    }
    /**
    * Retrieve tags with tagId of group with groupId
    * @summary Get a Group tag with tagId
    * @param {string} groupId GroupId
    * @param {string} tagId Tag ID
    * @throws {RequiredError}
    */
    getGroupTag(params) {
        // verify required parameter 'groupId' is not null or undefined
        if (params.groupId === null || params.groupId === undefined) {
            throw new utils_1.RequiredError('groupId', 'Required parameter groupId was null or undefined when calling getGroupTag.');
        }
        // verify required parameter 'tagId' is not null or undefined
        if (params.tagId === null || params.tagId === undefined) {
            throw new utils_1.RequiredError('tagId', 'Required parameter tagId was null or undefined when calling getGroupTag.');
        }
        const path = `/groups/{groupId}/tags/{tagId}`
            .replace(`{${'groupId'}}`, String(params.groupId))
            .replace(`{${'tagId'}}`, String(params.tagId));
        const headers = {};
        const query = {};
        let body = null;
        return this.serviceRequester.request({ method: 'GET', path, query, headers, body, options: params.options })
            .then(response => response.body);
    }
    /**
    * Retrieve tags with tagId of group with groupId
    * @summary Get a Group tag with tagId by Account
    * @param {string} accountId Account ID
    * @param {string} groupId GroupId
    * @param {string} tagId Tag ID
    * @throws {RequiredError}
    */
    getGroupTagByAccountId(params) {
        // verify required parameter 'accountId' is not null or undefined
        if (params.accountId === null || params.accountId === undefined) {
            throw new utils_1.RequiredError('accountId', 'Required parameter accountId was null or undefined when calling getGroupTagByAccountId.');
        }
        // verify required parameter 'groupId' is not null or undefined
        if (params.groupId === null || params.groupId === undefined) {
            throw new utils_1.RequiredError('groupId', 'Required parameter groupId was null or undefined when calling getGroupTagByAccountId.');
        }
        // verify required parameter 'tagId' is not null or undefined
        if (params.tagId === null || params.tagId === undefined) {
            throw new utils_1.RequiredError('tagId', 'Required parameter tagId was null or undefined when calling getGroupTagByAccountId.');
        }
        const path = `/accounts/{accountId}/groups/{groupId}/tags/{tagId}`
            .replace(`{${'accountId'}}`, String(params.accountId))
            .replace(`{${'groupId'}}`, String(params.groupId))
            .replace(`{${'tagId'}}`, String(params.tagId));
        const headers = {};
        const query = {};
        let body = null;
        return this.serviceRequester.request({ method: 'GET', path, query, headers, body, options: params.options })
            .then(response => response.body);
    }
    /**
    * Gets the tags set for the group
    * @summary Get tags of group
    * @param {string} groupId GroupId
    * @throws {RequiredError}
    */
    getGroupTags(params) {
        // verify required parameter 'groupId' is not null or undefined
        if (params.groupId === null || params.groupId === undefined) {
            throw new utils_1.RequiredError('groupId', 'Required parameter groupId was null or undefined when calling getGroupTags.');
        }
        const path = `/groups/{groupId}/tags`
            .replace(`{${'groupId'}}`, String(params.groupId));
        const headers = {};
        const query = {};
        let body = null;
        return this.serviceRequester.request({ method: 'GET', path, query, headers, body, options: params.options })
            .then(response => response.body);
    }
    /**
    * Gets the tags set for the group
    * @summary Get tags of group by Account
    * @param {string} accountId Account ID
    * @param {string} groupId GroupId
    * @throws {RequiredError}
    */
    getGroupTagsByAccountId(params) {
        // verify required parameter 'accountId' is not null or undefined
        if (params.accountId === null || params.accountId === undefined) {
            throw new utils_1.RequiredError('accountId', 'Required parameter accountId was null or undefined when calling getGroupTagsByAccountId.');
        }
        // verify required parameter 'groupId' is not null or undefined
        if (params.groupId === null || params.groupId === undefined) {
            throw new utils_1.RequiredError('groupId', 'Required parameter groupId was null or undefined when calling getGroupTagsByAccountId.');
        }
        const path = `/accounts/{accountId}/groups/{groupId}/tags`
            .replace(`{${'accountId'}}`, String(params.accountId))
            .replace(`{${'groupId'}}`, String(params.groupId));
        const headers = {};
        const query = {};
        let body = null;
        return this.serviceRequester.request({ method: 'GET', path, query, headers, body, options: params.options })
            .then(response => response.body);
    }
    /**
    * Retrieve all groups for the current token. Data is paged on the server and sorted by most recent groups first.
    * @summary Get Groups
    * @param {number} [$Skip] Number of items to skip
    * @param {number} [$Top] Number of items to include
    * @param {string} [$SkipToken] Use skipToken for the next scroll
    * @param {string} [$Filter] Odata filter param
    * @param {string} [$Search] text based search
    * @param {string} [$SearchKeys] a comma-separated list of keys to search in, e.g. name, email, tags. Used in conjunction with $search.
    * @param {string} [$Expand] expands an attribute
    * @param {string} [items] a comma-separated list of items to get, e.g. user-id-1, user-id-2
    * @param {string} [itemKeys] a comma-separated list of keys to lookup matching items in, e.g. userId, loginId, used in conjunction with items
    * @param {string} [$Orderby] a comma-separated list of fields and order to sort on, e.g. role asc, loginId desc.  Defaults to ascending when no order is specified.
    * @throws {RequiredError}
    */
    getGroups(params) {
        const path = `/groups`;
        const headers = {};
        const query = {};
        let body = null;
        if (params.$Skip !== undefined) {
            query['$skip'] = params.$Skip;
        }
        if (params.$Top !== undefined) {
            query['$top'] = params.$Top;
        }
        if (params.$SkipToken !== undefined) {
            query['$skipToken'] = params.$SkipToken;
        }
        if (params.$Filter !== undefined) {
            query['$filter'] = params.$Filter;
        }
        if (params.$Search !== undefined) {
            query['$search'] = params.$Search;
        }
        if (params.$SearchKeys !== undefined) {
            query['$searchKeys'] = params.$SearchKeys;
        }
        if (params.$Expand !== undefined) {
            query['$expand'] = params.$Expand;
        }
        if (params.items !== undefined) {
            query['items'] = params.items;
        }
        if (params.itemKeys !== undefined) {
            query['itemKeys'] = params.itemKeys;
        }
        if (params.$Orderby !== undefined) {
            query['$orderby'] = params.$Orderby;
        }
        return this.serviceRequester.request({ method: 'GET', path, query, headers, body, options: params.options })
            .then(response => response.body);
    }
    /**
    * Retrieve all groups for the current token. Data is paged on the server and sorted by most recent groups first.
    * @summary Get Groups by Account
    * @param {string} accountId Account ID
    * @param {number} [$Skip] Number of items to skip
    * @param {number} [$Top] Number of items to include
    * @param {string} [$SkipToken] Use skipToken for the next scroll
    * @param {string} [$Filter] Odata filter param
    * @param {string} [$Search] text based search
    * @param {string} [$SearchKeys] a comma-separated list of keys to search in, e.g. name, email, tags. Used in conjunction with $search.
    * @param {string} [$Expand] expands an attribute
    * @param {string} [items] a comma-separated list of items to get, e.g. user-id-1, user-id-2
    * @param {string} [itemKeys] a comma-separated list of keys to lookup matching items in, e.g. userId, loginId, used in conjunction with items
    * @param {string} [$Orderby] a comma-separated list of fields and order to sort on, e.g. role asc, loginId desc.  Defaults to ascending when no order is specified.
    * @throws {RequiredError}
    */
    getGroupsByAccountId(params) {
        // verify required parameter 'accountId' is not null or undefined
        if (params.accountId === null || params.accountId === undefined) {
            throw new utils_1.RequiredError('accountId', 'Required parameter accountId was null or undefined when calling getGroupsByAccountId.');
        }
        const path = `/accounts/{accountId}/groups`
            .replace(`{${'accountId'}}`, String(params.accountId));
        const headers = {};
        const query = {};
        let body = null;
        if (params.$Skip !== undefined) {
            query['$skip'] = params.$Skip;
        }
        if (params.$Top !== undefined) {
            query['$top'] = params.$Top;
        }
        if (params.$SkipToken !== undefined) {
            query['$skipToken'] = params.$SkipToken;
        }
        if (params.$Filter !== undefined) {
            query['$filter'] = params.$Filter;
        }
        if (params.$Search !== undefined) {
            query['$search'] = params.$Search;
        }
        if (params.$SearchKeys !== undefined) {
            query['$searchKeys'] = params.$SearchKeys;
        }
        if (params.$Expand !== undefined) {
            query['$expand'] = params.$Expand;
        }
        if (params.items !== undefined) {
            query['items'] = params.items;
        }
        if (params.itemKeys !== undefined) {
            query['itemKeys'] = params.itemKeys;
        }
        if (params.$Orderby !== undefined) {
            query['$orderby'] = params.$Orderby;
        }
        return this.serviceRequester.request({ method: 'GET', path, query, headers, body, options: params.options })
            .then(response => response.body);
    }
    /**
    * Retrieve all groups with tag of tagId expanded for the current token. Data is paged on the server and sorted by most recent groups first.
    * @summary Get Groups with tags expanded
    * @param {string} tagId Tag ID
    * @param {number} [$Skip] Number of items to skip
    * @param {number} [$Top] Number of items to include
    * @param {string} [$SkipToken] Use skipToken for the next scroll
    * @param {string} [skipTokenTimeout] The time (in seconds) that the result will be scrollable
    * @param {string} [$Filter] Odata filter param
    * @param {string} [$Search] text based search
    * @param {string} [$SearchKeys] a comma-separated list of keys to search in, e.g. name, email, tags. Used in conjunction with $search.
    * @throws {RequiredError}
    */
    getGroupsWithTag(params) {
        // verify required parameter 'tagId' is not null or undefined
        if (params.tagId === null || params.tagId === undefined) {
            throw new utils_1.RequiredError('tagId', 'Required parameter tagId was null or undefined when calling getGroupsWithTag.');
        }
        const path = `/groups/tags/{tagId}`
            .replace(`{${'tagId'}}`, String(params.tagId));
        const headers = {};
        const query = {};
        let body = null;
        if (params.$Skip !== undefined) {
            query['$skip'] = params.$Skip;
        }
        if (params.$Top !== undefined) {
            query['$top'] = params.$Top;
        }
        if (params.$SkipToken !== undefined) {
            query['$skipToken'] = params.$SkipToken;
        }
        if (params.skipTokenTimeout !== undefined) {
            query['skipTokenTimeout'] = params.skipTokenTimeout;
        }
        if (params.$Filter !== undefined) {
            query['$filter'] = params.$Filter;
        }
        if (params.$Search !== undefined) {
            query['$search'] = params.$Search;
        }
        if (params.$SearchKeys !== undefined) {
            query['$searchKeys'] = params.$SearchKeys;
        }
        return this.serviceRequester.request({ method: 'GET', path, query, headers, body, options: params.options })
            .then(response => response.body);
    }
    /**
    * Retrieve all groups with tag of tagId expanded for the current token. Data is paged on the server and sorted by most recent groups first.
    * @summary Get Groups by Account with tags expanded
    * @param {string} accountId Account ID
    * @param {string} tagId Tag ID
    * @throws {RequiredError}
    */
    getGroupsWithTagByAccountId(params) {
        // verify required parameter 'accountId' is not null or undefined
        if (params.accountId === null || params.accountId === undefined) {
            throw new utils_1.RequiredError('accountId', 'Required parameter accountId was null or undefined when calling getGroupsWithTagByAccountId.');
        }
        // verify required parameter 'tagId' is not null or undefined
        if (params.tagId === null || params.tagId === undefined) {
            throw new utils_1.RequiredError('tagId', 'Required parameter tagId was null or undefined when calling getGroupsWithTagByAccountId.');
        }
        const path = `/accounts/{accountId}/groups/tags/{tagId}`
            .replace(`{${'accountId'}}`, String(params.accountId))
            .replace(`{${'tagId'}}`, String(params.tagId));
        const headers = {};
        const query = {};
        let body = null;
        return this.serviceRequester.request({ method: 'GET', path, query, headers, body, options: params.options })
            .then(response => response.body);
    }
    /**
    * Retrieve all groups with tags expanded for the current token. Data is paged on the server and sorted by most recent groups first.
    * @summary Get Groups with tags expanded
    * @param {number} [$Skip] Number of items to skip
    * @param {number} [$Top] Number of items to include
    * @param {string} [$SkipToken] Use skipToken for the next scroll
    * @param {string} [$Filter] Odata filter param
    * @param {string} [$Search] text based search
    * @param {string} [$SearchKeys] a comma-separated list of keys to search in, e.g. name, email, tags. Used in conjunction with $search.
    * @throws {RequiredError}
    */
    getGroupsWithTags(params) {
        const path = `/groups/tags`;
        const headers = {};
        const query = {};
        let body = null;
        if (params.$Skip !== undefined) {
            query['$skip'] = params.$Skip;
        }
        if (params.$Top !== undefined) {
            query['$top'] = params.$Top;
        }
        if (params.$SkipToken !== undefined) {
            query['$skipToken'] = params.$SkipToken;
        }
        if (params.$Filter !== undefined) {
            query['$filter'] = params.$Filter;
        }
        if (params.$Search !== undefined) {
            query['$search'] = params.$Search;
        }
        if (params.$SearchKeys !== undefined) {
            query['$searchKeys'] = params.$SearchKeys;
        }
        return this.serviceRequester.request({ method: 'GET', path, query, headers, body, options: params.options })
            .then(response => response.body);
    }
    /**
    * Retrieve all groups with tags expanded for the current token. Data is paged on the server and sorted by most recent groups first.
    * @summary Get Groups by Account with tags expanded
    * @param {string} accountId Account ID
    * @param {number} [$Skip] Number of items to skip
    * @param {number} [$Top] Number of items to include
    * @param {string} [$SkipToken] Use skipToken for the next scroll
    * @param {string} [$Filter] Odata filter param
    * @param {string} [$Search] text based search
    * @param {string} [$SearchKeys] a comma-separated list of keys to search in, e.g. name, email, tags. Used in conjunction with $search.
    * @throws {RequiredError}
    */
    getGroupsWithTagsByAccountId(params) {
        // verify required parameter 'accountId' is not null or undefined
        if (params.accountId === null || params.accountId === undefined) {
            throw new utils_1.RequiredError('accountId', 'Required parameter accountId was null or undefined when calling getGroupsWithTagsByAccountId.');
        }
        const path = `/accounts/{accountId}/groups/tags`
            .replace(`{${'accountId'}}`, String(params.accountId));
        const headers = {};
        const query = {};
        let body = null;
        if (params.$Skip !== undefined) {
            query['$skip'] = params.$Skip;
        }
        if (params.$Top !== undefined) {
            query['$top'] = params.$Top;
        }
        if (params.$SkipToken !== undefined) {
            query['$skipToken'] = params.$SkipToken;
        }
        if (params.$Filter !== undefined) {
            query['$filter'] = params.$Filter;
        }
        if (params.$Search !== undefined) {
            query['$search'] = params.$Search;
        }
        if (params.$SearchKeys !== undefined) {
            query['$searchKeys'] = params.$SearchKeys;
        }
        return this.serviceRequester.request({ method: 'GET', path, query, headers, body, options: params.options })
            .then(response => response.body);
    }
    /**
    * Batch of operations to create, update, delete multiple groups in one request
    * @summary Patch groups
    * @param {PatchRequest} body
    * @throws {RequiredError}
    */
    patchGroups(params) {
        // verify required parameter 'body' is not null or undefined
        if (params.body === null || params.body === undefined) {
            throw new utils_1.RequiredError('body', 'Required parameter body was null or undefined when calling patchGroups.');
        }
        const path = `/groups`;
        const headers = {};
        const query = {};
        let body = null;
        body = params.body || {};
        return this.serviceRequester.request({ method: 'PATCH', path, query, headers, body, options: params.options })
            .then(response => response.body);
    }
    /**
    * Batch of operations to create, update, delete multiple groups in one request
    * @summary Patch groups in Account
    * @param {string} accountId Account ID
    * @param {PatchRequest} body
    * @throws {RequiredError}
    */
    patchGroupsByAccountId(params) {
        // verify required parameter 'accountId' is not null or undefined
        if (params.accountId === null || params.accountId === undefined) {
            throw new utils_1.RequiredError('accountId', 'Required parameter accountId was null or undefined when calling patchGroupsByAccountId.');
        }
        // verify required parameter 'body' is not null or undefined
        if (params.body === null || params.body === undefined) {
            throw new utils_1.RequiredError('body', 'Required parameter body was null or undefined when calling patchGroupsByAccountId.');
        }
        const path = `/accounts/{accountId}/groups`
            .replace(`{${'accountId'}}`, String(params.accountId));
        const headers = {};
        const query = {};
        let body = null;
        body = params.body || {};
        return this.serviceRequester.request({ method: 'PATCH', path, query, headers, body, options: params.options })
            .then(response => response.body);
    }
    /**
    * Updates a group by id. This route should only be used when the caller wants to update a group in the same account (i.e. account in the token).
    * @summary Update a Group
    * @param {string} groupId GroupId
    * @param {GroupPutRequest} body
    * @throws {RequiredError}
    */
    updateGroup(params) {
        // verify required parameter 'groupId' is not null or undefined
        if (params.groupId === null || params.groupId === undefined) {
            throw new utils_1.RequiredError('groupId', 'Required parameter groupId was null or undefined when calling updateGroup.');
        }
        // verify required parameter 'body' is not null or undefined
        if (params.body === null || params.body === undefined) {
            throw new utils_1.RequiredError('body', 'Required parameter body was null or undefined when calling updateGroup.');
        }
        const path = `/groups/{groupId}`
            .replace(`{${'groupId'}}`, String(params.groupId));
        const headers = {};
        const query = {};
        let body = null;
        body = params.body || {};
        return this.serviceRequester.request({ method: 'PUT', path, query, headers, body, options: params.options })
            .then(response => response.body);
    }
    /**
    * Updates a group by id
    * @summary Update a Group by Account
    * @param {string} accountId Account ID
    * @param {string} groupId GroupId
    * @param {GroupPutRequest} body
    * @throws {RequiredError}
    */
    updateGroupByAccountId(params) {
        // verify required parameter 'accountId' is not null or undefined
        if (params.accountId === null || params.accountId === undefined) {
            throw new utils_1.RequiredError('accountId', 'Required parameter accountId was null or undefined when calling updateGroupByAccountId.');
        }
        // verify required parameter 'groupId' is not null or undefined
        if (params.groupId === null || params.groupId === undefined) {
            throw new utils_1.RequiredError('groupId', 'Required parameter groupId was null or undefined when calling updateGroupByAccountId.');
        }
        // verify required parameter 'body' is not null or undefined
        if (params.body === null || params.body === undefined) {
            throw new utils_1.RequiredError('body', 'Required parameter body was null or undefined when calling updateGroupByAccountId.');
        }
        const path = `/accounts/{accountId}/groups/{groupId}`
            .replace(`{${'accountId'}}`, String(params.accountId))
            .replace(`{${'groupId'}}`, String(params.groupId));
        const headers = {};
        const query = {};
        let body = null;
        body = params.body || {};
        return this.serviceRequester.request({ method: 'PUT', path, query, headers, body, options: params.options })
            .then(response => response.body);
    }
    /**
    * Update tag with of a group with groupId.
    * @summary Update a Group tag
    * @param {string} groupId GroupId
    * @param {string} tagId Tag ID
    * @param {TagPutRequest} body
    * @throws {RequiredError}
    */
    updateGroupTag(params) {
        // verify required parameter 'groupId' is not null or undefined
        if (params.groupId === null || params.groupId === undefined) {
            throw new utils_1.RequiredError('groupId', 'Required parameter groupId was null or undefined when calling updateGroupTag.');
        }
        // verify required parameter 'tagId' is not null or undefined
        if (params.tagId === null || params.tagId === undefined) {
            throw new utils_1.RequiredError('tagId', 'Required parameter tagId was null or undefined when calling updateGroupTag.');
        }
        // verify required parameter 'body' is not null or undefined
        if (params.body === null || params.body === undefined) {
            throw new utils_1.RequiredError('body', 'Required parameter body was null or undefined when calling updateGroupTag.');
        }
        const path = `/groups/{groupId}/tags/{tagId}`
            .replace(`{${'groupId'}}`, String(params.groupId))
            .replace(`{${'tagId'}}`, String(params.tagId));
        const headers = {};
        const query = {};
        let body = null;
        body = params.body || {};
        return this.serviceRequester.request({ method: 'PUT', path, query, headers, body, options: params.options })
            .then(response => response.body);
    }
    /**
    * Update tag with of a group with groupId.
    * @summary Update a Group tag by Account
    * @param {string} accountId Account ID
    * @param {string} groupId GroupId
    * @param {string} tagId Tag ID
    * @param {TagPutRequest} body
    * @throws {RequiredError}
    */
    updateGroupTagByAccountId(params) {
        // verify required parameter 'accountId' is not null or undefined
        if (params.accountId === null || params.accountId === undefined) {
            throw new utils_1.RequiredError('accountId', 'Required parameter accountId was null or undefined when calling updateGroupTagByAccountId.');
        }
        // verify required parameter 'groupId' is not null or undefined
        if (params.groupId === null || params.groupId === undefined) {
            throw new utils_1.RequiredError('groupId', 'Required parameter groupId was null or undefined when calling updateGroupTagByAccountId.');
        }
        // verify required parameter 'tagId' is not null or undefined
        if (params.tagId === null || params.tagId === undefined) {
            throw new utils_1.RequiredError('tagId', 'Required parameter tagId was null or undefined when calling updateGroupTagByAccountId.');
        }
        // verify required parameter 'body' is not null or undefined
        if (params.body === null || params.body === undefined) {
            throw new utils_1.RequiredError('body', 'Required parameter body was null or undefined when calling updateGroupTagByAccountId.');
        }
        const path = `/accounts/{accountId}/groups/{groupId}/tags/{tagId}`
            .replace(`{${'accountId'}}`, String(params.accountId))
            .replace(`{${'groupId'}}`, String(params.groupId))
            .replace(`{${'tagId'}}`, String(params.tagId));
        const headers = {};
        const query = {};
        let body = null;
        body = params.body || {};
        return this.serviceRequester.request({ method: 'PUT', path, query, headers, body, options: params.options })
            .then(response => response.body);
    }
    /**
    * Add the Members to the provided Group.
    * @summary Add Members to Group
    * @param {string} groupId GroupId
    * @param {GroupMemberPostRequest} body
    * @throws {RequiredError}
    */
    createGroupMember(params) {
        // verify required parameter 'groupId' is not null or undefined
        if (params.groupId === null || params.groupId === undefined) {
            throw new utils_1.RequiredError('groupId', 'Required parameter groupId was null or undefined when calling createGroupMember.');
        }
        // verify required parameter 'body' is not null or undefined
        if (params.body === null || params.body === undefined) {
            throw new utils_1.RequiredError('body', 'Required parameter body was null or undefined when calling createGroupMember.');
        }
        const path = `/groups/{groupId}/members`
            .replace(`{${'groupId'}}`, String(params.groupId));
        const headers = {};
        const query = {};
        let body = null;
        body = params.body || {};
        return this.serviceRequester.request({ method: 'POST', path, query, headers, body, options: params.options })
            .then(response => response.body);
    }
    /**
    * Add the Members to the provided Group.
    * @summary Add Members to Group by Account
    * @param {string} accountId Account ID
    * @param {string} groupId GroupId
    * @param {GroupMemberPostRequest} body
    * @throws {RequiredError}
    */
    createGroupMemberByAccountId(params) {
        // verify required parameter 'accountId' is not null or undefined
        if (params.accountId === null || params.accountId === undefined) {
            throw new utils_1.RequiredError('accountId', 'Required parameter accountId was null or undefined when calling createGroupMemberByAccountId.');
        }
        // verify required parameter 'groupId' is not null or undefined
        if (params.groupId === null || params.groupId === undefined) {
            throw new utils_1.RequiredError('groupId', 'Required parameter groupId was null or undefined when calling createGroupMemberByAccountId.');
        }
        // verify required parameter 'body' is not null or undefined
        if (params.body === null || params.body === undefined) {
            throw new utils_1.RequiredError('body', 'Required parameter body was null or undefined when calling createGroupMemberByAccountId.');
        }
        const path = `/accounts/{accountId}/groups/{groupId}/members`
            .replace(`{${'accountId'}}`, String(params.accountId))
            .replace(`{${'groupId'}}`, String(params.groupId));
        const headers = {};
        const query = {};
        let body = null;
        body = params.body || {};
        return this.serviceRequester.request({ method: 'POST', path, query, headers, body, options: params.options })
            .then(response => response.body);
    }
    /**
    * Deletes a member by Id from group
    * @summary Delete a member from group
    * @param {string} groupId GroupId
    * @param {string} memberId Member ID
    * @throws {RequiredError}
    */
    deleteGroupMember(params) {
        // verify required parameter 'groupId' is not null or undefined
        if (params.groupId === null || params.groupId === undefined) {
            throw new utils_1.RequiredError('groupId', 'Required parameter groupId was null or undefined when calling deleteGroupMember.');
        }
        // verify required parameter 'memberId' is not null or undefined
        if (params.memberId === null || params.memberId === undefined) {
            throw new utils_1.RequiredError('memberId', 'Required parameter memberId was null or undefined when calling deleteGroupMember.');
        }
        const path = `/groups/{groupId}/members/{memberId}`
            .replace(`{${'groupId'}}`, String(params.groupId))
            .replace(`{${'memberId'}}`, String(params.memberId));
        const headers = {};
        const query = {};
        let body = null;
        return this.serviceRequester.request({ method: 'DELETE', path, query, headers, body, options: params.options })
            .then(response => response.body);
    }
    /**
    * Deletes a member by Id from group
    * @summary Delete a Group Member by Account
    * @param {string} accountId Account ID
    * @param {string} groupId GroupId
    * @param {string} memberId Member ID
    * @throws {RequiredError}
    */
    deleteGroupMemberByAccountId(params) {
        // verify required parameter 'accountId' is not null or undefined
        if (params.accountId === null || params.accountId === undefined) {
            throw new utils_1.RequiredError('accountId', 'Required parameter accountId was null or undefined when calling deleteGroupMemberByAccountId.');
        }
        // verify required parameter 'groupId' is not null or undefined
        if (params.groupId === null || params.groupId === undefined) {
            throw new utils_1.RequiredError('groupId', 'Required parameter groupId was null or undefined when calling deleteGroupMemberByAccountId.');
        }
        // verify required parameter 'memberId' is not null or undefined
        if (params.memberId === null || params.memberId === undefined) {
            throw new utils_1.RequiredError('memberId', 'Required parameter memberId was null or undefined when calling deleteGroupMemberByAccountId.');
        }
        const path = `/accounts/{accountId}/groups/{groupId}/members/{memberId}`
            .replace(`{${'accountId'}}`, String(params.accountId))
            .replace(`{${'groupId'}}`, String(params.groupId))
            .replace(`{${'memberId'}}`, String(params.memberId));
        const headers = {};
        const query = {};
        let body = null;
        return this.serviceRequester.request({ method: 'DELETE', path, query, headers, body, options: params.options })
            .then(response => response.body);
    }
    /**
    * Retrieve all members in the group for the current token.
    * @summary Get Group Members
    * @param {string} groupId GroupId
    * @throws {RequiredError}
    */
    getGroupMembers(params) {
        // verify required parameter 'groupId' is not null or undefined
        if (params.groupId === null || params.groupId === undefined) {
            throw new utils_1.RequiredError('groupId', 'Required parameter groupId was null or undefined when calling getGroupMembers.');
        }
        const path = `/groups/{groupId}/members`
            .replace(`{${'groupId'}}`, String(params.groupId));
        const headers = {};
        const query = {};
        let body = null;
        return this.serviceRequester.request({ method: 'GET', path, query, headers, body, options: params.options })
            .then(response => response.body);
    }
    /**
    * Retrieve all members in the group for the current token.
    * @summary Get Group Members by Account
    * @param {string} accountId Account ID
    * @param {string} groupId GroupId
    * @throws {RequiredError}
    */
    getGroupMembersByAccountId(params) {
        // verify required parameter 'accountId' is not null or undefined
        if (params.accountId === null || params.accountId === undefined) {
            throw new utils_1.RequiredError('accountId', 'Required parameter accountId was null or undefined when calling getGroupMembersByAccountId.');
        }
        // verify required parameter 'groupId' is not null or undefined
        if (params.groupId === null || params.groupId === undefined) {
            throw new utils_1.RequiredError('groupId', 'Required parameter groupId was null or undefined when calling getGroupMembersByAccountId.');
        }
        const path = `/accounts/{accountId}/groups/{groupId}/members`
            .replace(`{${'accountId'}}`, String(params.accountId))
            .replace(`{${'groupId'}}`, String(params.groupId));
        const headers = {};
        const query = {};
        let body = null;
        return this.serviceRequester.request({ method: 'GET', path, query, headers, body, options: params.options })
            .then(response => response.body);
    }
    /**
    * Updates a Member by id
    * @summary Update a Group Member
    * @param {string} groupId GroupId
    * @param {string} memberId Member ID
    * @param {GroupMemberPutRequest} body
    * @throws {RequiredError}
    */
    updateGroupMember(params) {
        // verify required parameter 'groupId' is not null or undefined
        if (params.groupId === null || params.groupId === undefined) {
            throw new utils_1.RequiredError('groupId', 'Required parameter groupId was null or undefined when calling updateGroupMember.');
        }
        // verify required parameter 'memberId' is not null or undefined
        if (params.memberId === null || params.memberId === undefined) {
            throw new utils_1.RequiredError('memberId', 'Required parameter memberId was null or undefined when calling updateGroupMember.');
        }
        // verify required parameter 'body' is not null or undefined
        if (params.body === null || params.body === undefined) {
            throw new utils_1.RequiredError('body', 'Required parameter body was null or undefined when calling updateGroupMember.');
        }
        const path = `/groups/{groupId}/members/{memberId}`
            .replace(`{${'groupId'}}`, String(params.groupId))
            .replace(`{${'memberId'}}`, String(params.memberId));
        const headers = {};
        const query = {};
        let body = null;
        body = params.body || {};
        return this.serviceRequester.request({ method: 'PUT', path, query, headers, body, options: params.options })
            .then(response => response.body);
    }
    /**
    * Updates a Member by id
    * @summary Update a Group Member by Account
    * @param {string} accountId Account ID
    * @param {string} groupId GroupId
    * @param {string} memberId Member ID
    * @param {GroupMemberPutRequest} body
    * @throws {RequiredError}
    */
    updateGroupMemberByAccountId(params) {
        // verify required parameter 'accountId' is not null or undefined
        if (params.accountId === null || params.accountId === undefined) {
            throw new utils_1.RequiredError('accountId', 'Required parameter accountId was null or undefined when calling updateGroupMemberByAccountId.');
        }
        // verify required parameter 'groupId' is not null or undefined
        if (params.groupId === null || params.groupId === undefined) {
            throw new utils_1.RequiredError('groupId', 'Required parameter groupId was null or undefined when calling updateGroupMemberByAccountId.');
        }
        // verify required parameter 'memberId' is not null or undefined
        if (params.memberId === null || params.memberId === undefined) {
            throw new utils_1.RequiredError('memberId', 'Required parameter memberId was null or undefined when calling updateGroupMemberByAccountId.');
        }
        // verify required parameter 'body' is not null or undefined
        if (params.body === null || params.body === undefined) {
            throw new utils_1.RequiredError('body', 'Required parameter body was null or undefined when calling updateGroupMemberByAccountId.');
        }
        const path = `/accounts/{accountId}/groups/{groupId}/members/{memberId}`
            .replace(`{${'accountId'}}`, String(params.accountId))
            .replace(`{${'groupId'}}`, String(params.groupId))
            .replace(`{${'memberId'}}`, String(params.memberId));
        const headers = {};
        const query = {};
        let body = null;
        body = params.body || {};
        return this.serviceRequester.request({ method: 'PUT', path, query, headers, body, options: params.options })
            .then(response => response.body);
    }
    /**
    * Creates a new Partner, this will also create a default Account for the Partner with the parameters provided. Token needs to be a GLOBAL_ADMIN role
    * @summary Create a Partner
    * @param {PartnerPostRequest} body
    * @throws {RequiredError}
    */
    createPartner(params) {
        // verify required parameter 'body' is not null or undefined
        if (params.body === null || params.body === undefined) {
            throw new utils_1.RequiredError('body', 'Required parameter body was null or undefined when calling createPartner.');
        }
        const path = `/partners`;
        const headers = {};
        const query = {};
        let body = null;
        body = params.body || {};
        return this.serviceRequester.request({ method: 'POST', path, query, headers, body, options: params.options })
            .then(response => response.body);
    }
    /**
    * Deletes the partner with partnerId. Token needs to be a GLOBAL_ADMIN role
    * @summary Delete a Partner
    * @param {string} partnerId The ID of the partner
    * @param {string} [hard] use &#39;true&#39; to completely delete the given resource and associated sub-resources
    * @throws {RequiredError}
    */
    deletePartner(params) {
        // verify required parameter 'partnerId' is not null or undefined
        if (params.partnerId === null || params.partnerId === undefined) {
            throw new utils_1.RequiredError('partnerId', 'Required parameter partnerId was null or undefined when calling deletePartner.');
        }
        const path = `/partners/{partnerId}`
            .replace(`{${'partnerId'}}`, String(params.partnerId));
        const headers = {};
        const query = {};
        let body = null;
        if (params.hard !== undefined) {
            query['hard'] = params.hard;
        }
        return this.serviceRequester.request({ method: 'DELETE', path, query, headers, body, options: params.options })
            .then(response => response.body);
    }
    /**
    * Returns the partner by partnerId. Token needs to be a GLOBAL_ADMIN role
    * @summary Get a Partner
    * @param {string} partnerId
    * @throws {RequiredError}
    */
    getPartner(params) {
        // verify required parameter 'partnerId' is not null or undefined
        if (params.partnerId === null || params.partnerId === undefined) {
            throw new utils_1.RequiredError('partnerId', 'Required parameter partnerId was null or undefined when calling getPartner.');
        }
        const path = `/partners/{partnerId}`
            .replace(`{${'partnerId'}}`, String(params.partnerId));
        const headers = {};
        const query = {};
        let body = null;
        return this.serviceRequester.request({ method: 'GET', path, query, headers, body, options: params.options })
            .then(response => response.body);
    }
    /**
    * Retrieve all partners if role is `GLOBAL_ADMIN`. Data is paged on the server and sorted by most recent partner first.
    * @summary Get Partners
    * @param {number} [$Top] Number of items to include
    * @param {number} [$Skip] Number of items to skip
    * @param {string} [$SkipToken] Use skipToken for the next scroll
    * @throws {RequiredError}
    */
    getPartners(params) {
        const path = `/partners`;
        const headers = {};
        const query = {};
        let body = null;
        if (params.$Top !== undefined) {
            query['$top'] = params.$Top;
        }
        if (params.$Skip !== undefined) {
            query['$skip'] = params.$Skip;
        }
        if (params.$SkipToken !== undefined) {
            query['$skipToken'] = params.$SkipToken;
        }
        return this.serviceRequester.request({ method: 'GET', path, query, headers, body, options: params.options })
            .then(response => response.body);
    }
    /**
    * Updates the partner by partnerId. Token needs to be a GLOBAL_ADMIN role
    * @summary Update a Partner
    * @param {string} partnerId
    * @param {PartnerPutRequest} body
    * @throws {RequiredError}
    */
    updatePartner(params) {
        // verify required parameter 'partnerId' is not null or undefined
        if (params.partnerId === null || params.partnerId === undefined) {
            throw new utils_1.RequiredError('partnerId', 'Required parameter partnerId was null or undefined when calling updatePartner.');
        }
        // verify required parameter 'body' is not null or undefined
        if (params.body === null || params.body === undefined) {
            throw new utils_1.RequiredError('body', 'Required parameter body was null or undefined when calling updatePartner.');
        }
        const path = `/partners/{partnerId}`
            .replace(`{${'partnerId'}}`, String(params.partnerId));
        const headers = {};
        const query = {};
        let body = null;
        body = params.body || {};
        return this.serviceRequester.request({ method: 'PUT', path, query, headers, body, options: params.options })
            .then(response => response.body);
    }
    /**
    * Deletes a photo avatars for contact
    * @summary Deletes photo for contact
    * @param {string} contactId Contact ID
    * @throws {RequiredError}
    */
    deleteContactPhoto(params) {
        // verify required parameter 'contactId' is not null or undefined
        if (params.contactId === null || params.contactId === undefined) {
            throw new utils_1.RequiredError('contactId', 'Required parameter contactId was null or undefined when calling deleteContactPhoto.');
        }
        const path = `/contacts/{contactId}/photo`
            .replace(`{${'contactId'}}`, String(params.contactId));
        const headers = {};
        const query = {};
        let body = null;
        return this.serviceRequester.request({ method: 'DELETE', path, query, headers, body, options: params.options })
            .then(response => response.body);
    }
    /**
    * Deletes a photo avatars for contact
    * @summary Deletes Photo for Contact by Account
    * @param {string} accountId Account ID
    * @param {string} contactId Contact ID
    * @throws {RequiredError}
    */
    deleteContactPhotoByAccountId(params) {
        // verify required parameter 'accountId' is not null or undefined
        if (params.accountId === null || params.accountId === undefined) {
            throw new utils_1.RequiredError('accountId', 'Required parameter accountId was null or undefined when calling deleteContactPhotoByAccountId.');
        }
        // verify required parameter 'contactId' is not null or undefined
        if (params.contactId === null || params.contactId === undefined) {
            throw new utils_1.RequiredError('contactId', 'Required parameter contactId was null or undefined when calling deleteContactPhotoByAccountId.');
        }
        const path = `/accounts/{accountId}/contacts/{contactId}/photo`
            .replace(`{${'accountId'}}`, String(params.accountId))
            .replace(`{${'contactId'}}`, String(params.contactId));
        const headers = {};
        const query = {};
        let body = null;
        return this.serviceRequester.request({ method: 'DELETE', path, query, headers, body, options: params.options })
            .then(response => response.body);
    }
    /**
    * Deletes a photo
    * @summary Delete a User Photo
    * @param {string} userId User ID
    * @throws {RequiredError}
    */
    deleteUserPhoto(params) {
        // verify required parameter 'userId' is not null or undefined
        if (params.userId === null || params.userId === undefined) {
            throw new utils_1.RequiredError('userId', 'Required parameter userId was null or undefined when calling deleteUserPhoto.');
        }
        const path = `/users/{userId}/photo`
            .replace(`{${'userId'}}`, String(params.userId));
        const headers = {};
        const query = {};
        let body = null;
        return this.serviceRequester.request({ method: 'DELETE', path, query, headers, body, options: params.options })
            .then(response => response.body);
    }
    /**
    * Deletes a photo
    * @summary Delete a User photo by Account
    * @param {string} accountId Account ID
    * @param {string} userId User ID
    * @throws {RequiredError}
    */
    deleteUserPhotoByAccountId(params) {
        // verify required parameter 'accountId' is not null or undefined
        if (params.accountId === null || params.accountId === undefined) {
            throw new utils_1.RequiredError('accountId', 'Required parameter accountId was null or undefined when calling deleteUserPhotoByAccountId.');
        }
        // verify required parameter 'userId' is not null or undefined
        if (params.userId === null || params.userId === undefined) {
            throw new utils_1.RequiredError('userId', 'Required parameter userId was null or undefined when calling deleteUserPhotoByAccountId.');
        }
        const path = `/accounts/{accountId}/users/{userId}/photo`
            .replace(`{${'accountId'}}`, String(params.accountId))
            .replace(`{${'userId'}}`, String(params.userId));
        const headers = {};
        const query = {};
        let body = null;
        return this.serviceRequester.request({ method: 'DELETE', path, query, headers, body, options: params.options })
            .then(response => response.body);
    }
    /**
    * Uploads a contact's photo and creates scaled/resized avatars and stores as jpeg.
    * @summary Upload a Contact Photo
    * @param {string} contactId Contact ID
    * @param {string} body Binary data of photo
    * @throws {RequiredError}
    */
    updateContactPhoto(params) {
        // verify required parameter 'contactId' is not null or undefined
        if (params.contactId === null || params.contactId === undefined) {
            throw new utils_1.RequiredError('contactId', 'Required parameter contactId was null or undefined when calling updateContactPhoto.');
        }
        // verify required parameter 'body' is not null or undefined
        if (params.body === null || params.body === undefined) {
            throw new utils_1.RequiredError('body', 'Required parameter body was null or undefined when calling updateContactPhoto.');
        }
        const path = `/contacts/{contactId}/photo`
            .replace(`{${'contactId'}}`, String(params.contactId));
        const headers = {};
        const query = {};
        let body = null;
        body = params.body || {};
        return this.serviceRequester.request({ method: 'PUT', path, query, headers, body, options: params.options })
            .then(response => response.body);
    }
    /**
    * Uploads a contact's photo and creates scaled/resized avatars and stores as jpeg.
    * @summary Upload a Contact Photo by Account
    * @param {string} accountId Account ID
    * @param {string} contactId Contact ID
    * @param {string} body Binary data of photo
    * @throws {RequiredError}
    */
    updateContactPhotoByAccountId(params) {
        // verify required parameter 'accountId' is not null or undefined
        if (params.accountId === null || params.accountId === undefined) {
            throw new utils_1.RequiredError('accountId', 'Required parameter accountId was null or undefined when calling updateContactPhotoByAccountId.');
        }
        // verify required parameter 'contactId' is not null or undefined
        if (params.contactId === null || params.contactId === undefined) {
            throw new utils_1.RequiredError('contactId', 'Required parameter contactId was null or undefined when calling updateContactPhotoByAccountId.');
        }
        // verify required parameter 'body' is not null or undefined
        if (params.body === null || params.body === undefined) {
            throw new utils_1.RequiredError('body', 'Required parameter body was null or undefined when calling updateContactPhotoByAccountId.');
        }
        const path = `/accounts/{accountId}/contacts/{contactId}/photo`
            .replace(`{${'accountId'}}`, String(params.accountId))
            .replace(`{${'contactId'}}`, String(params.contactId));
        const headers = {};
        const query = {};
        let body = null;
        body = params.body || {};
        return this.serviceRequester.request({ method: 'PUT', path, query, headers, body, options: params.options })
            .then(response => response.body);
    }
    /**
    * Uploads a group's photo and creates scaled/resized avatars and stores as jpeg. This route should only be used when the caller wants to update the photo of a group in the same account.
    * @summary Upload a photo
    * @param {string} groupId GroupId
    * @param {string} body Binary data of photo
    * @throws {RequiredError}
    */
    updateGroupPhoto(params) {
        // verify required parameter 'groupId' is not null or undefined
        if (params.groupId === null || params.groupId === undefined) {
            throw new utils_1.RequiredError('groupId', 'Required parameter groupId was null or undefined when calling updateGroupPhoto.');
        }
        // verify required parameter 'body' is not null or undefined
        if (params.body === null || params.body === undefined) {
            throw new utils_1.RequiredError('body', 'Required parameter body was null or undefined when calling updateGroupPhoto.');
        }
        const path = `/groups/{groupId}/photo`
            .replace(`{${'groupId'}}`, String(params.groupId));
        const headers = {};
        const query = {};
        let body = null;
        body = params.body || {};
        return this.serviceRequester.request({ method: 'PUT', path, query, headers, body, options: params.options })
            .then(response => response.body);
    }
    /**
    * Uploads a group's photo and creates scaled/resized avatars and stores as jpeg.
    * @summary Upload a Group Photo by Account
    * @param {string} accountId Account ID
    * @param {string} groupId GroupId
    * @param {string} body Binary data of photo
    * @throws {RequiredError}
    */
    updateGroupPhotoByAccountId(params) {
        // verify required parameter 'accountId' is not null or undefined
        if (params.accountId === null || params.accountId === undefined) {
            throw new utils_1.RequiredError('accountId', 'Required parameter accountId was null or undefined when calling updateGroupPhotoByAccountId.');
        }
        // verify required parameter 'groupId' is not null or undefined
        if (params.groupId === null || params.groupId === undefined) {
            throw new utils_1.RequiredError('groupId', 'Required parameter groupId was null or undefined when calling updateGroupPhotoByAccountId.');
        }
        // verify required parameter 'body' is not null or undefined
        if (params.body === null || params.body === undefined) {
            throw new utils_1.RequiredError('body', 'Required parameter body was null or undefined when calling updateGroupPhotoByAccountId.');
        }
        const path = `/accounts/{accountId}/groups/{groupId}/photo`
            .replace(`{${'accountId'}}`, String(params.accountId))
            .replace(`{${'groupId'}}`, String(params.groupId));
        const headers = {};
        const query = {};
        let body = null;
        body = params.body || {};
        return this.serviceRequester.request({ method: 'PUT', path, query, headers, body, options: params.options })
            .then(response => response.body);
    }
    /**
    * Uploads a user's photo and creates scaled/resized avatars and stores as jpeg.
    * @summary Upload a User Photo
    * @param {string} userId User ID
    * @param {string} body Binary data of photo
    * @throws {RequiredError}
    */
    updateUserPhoto(params) {
        // verify required parameter 'userId' is not null or undefined
        if (params.userId === null || params.userId === undefined) {
            throw new utils_1.RequiredError('userId', 'Required parameter userId was null or undefined when calling updateUserPhoto.');
        }
        // verify required parameter 'body' is not null or undefined
        if (params.body === null || params.body === undefined) {
            throw new utils_1.RequiredError('body', 'Required parameter body was null or undefined when calling updateUserPhoto.');
        }
        const path = `/users/{userId}/photo`
            .replace(`{${'userId'}}`, String(params.userId));
        const headers = {};
        const query = {};
        let body = null;
        body = params.body || {};
        return this.serviceRequester.request({ method: 'PUT', path, query, headers, body, options: params.options })
            .then(response => response.body);
    }
    /**
    * Uploads a user's photo and creates scaled/resized avatars and stores as jpeg.
    * @summary Upload a User Photo by Account
    * @param {string} accountId Account ID
    * @param {string} userId User ID
    * @param {string} body Binary data of photo
    * @throws {RequiredError}
    */
    updateUserPhotoByAccountId(params) {
        // verify required parameter 'accountId' is not null or undefined
        if (params.accountId === null || params.accountId === undefined) {
            throw new utils_1.RequiredError('accountId', 'Required parameter accountId was null or undefined when calling updateUserPhotoByAccountId.');
        }
        // verify required parameter 'userId' is not null or undefined
        if (params.userId === null || params.userId === undefined) {
            throw new utils_1.RequiredError('userId', 'Required parameter userId was null or undefined when calling updateUserPhotoByAccountId.');
        }
        // verify required parameter 'body' is not null or undefined
        if (params.body === null || params.body === undefined) {
            throw new utils_1.RequiredError('body', 'Required parameter body was null or undefined when calling updateUserPhotoByAccountId.');
        }
        const path = `/accounts/{accountId}/users/{userId}/photo`
            .replace(`{${'accountId'}}`, String(params.accountId))
            .replace(`{${'userId'}}`, String(params.userId));
        const headers = {};
        const query = {};
        let body = null;
        body = params.body || {};
        return this.serviceRequester.request({ method: 'PUT', path, query, headers, body, options: params.options })
            .then(response => response.body);
    }
    /**
    * Create a new account access policy
    * @summary Create a new account access policy
    * @param {string} accountId Account ID
    * @param {PolicyPostRequest} body
    * @throws {RequiredError}
    */
    createAccountAccessPolicy(params) {
        // verify required parameter 'accountId' is not null or undefined
        if (params.accountId === null || params.accountId === undefined) {
            throw new utils_1.RequiredError('accountId', 'Required parameter accountId was null or undefined when calling createAccountAccessPolicy.');
        }
        // verify required parameter 'body' is not null or undefined
        if (params.body === null || params.body === undefined) {
            throw new utils_1.RequiredError('body', 'Required parameter body was null or undefined when calling createAccountAccessPolicy.');
        }
        const path = `/accounts/{accountId}/policies`
            .replace(`{${'accountId'}}`, String(params.accountId));
        const headers = {};
        const query = {};
        let body = null;
        body = params.body || {};
        return this.serviceRequester.request({ method: 'POST', path, query, headers, body, options: params.options })
            .then(response => response.body);
    }
    /**
    * Delete an account access policy
    * @summary Delete an account access policy
    * @param {string} accountId Account ID
    * @param {string} policyId Policy ID
    * @throws {RequiredError}
    */
    deleteAccountAccessPolicy(params) {
        // verify required parameter 'accountId' is not null or undefined
        if (params.accountId === null || params.accountId === undefined) {
            throw new utils_1.RequiredError('accountId', 'Required parameter accountId was null or undefined when calling deleteAccountAccessPolicy.');
        }
        // verify required parameter 'policyId' is not null or undefined
        if (params.policyId === null || params.policyId === undefined) {
            throw new utils_1.RequiredError('policyId', 'Required parameter policyId was null or undefined when calling deleteAccountAccessPolicy.');
        }
        const path = `/accounts/{accountId}/policies/{policyId}`
            .replace(`{${'accountId'}}`, String(params.accountId))
            .replace(`{${'policyId'}}`, String(params.policyId));
        const headers = {};
        const query = {};
        let body = null;
        return this.serviceRequester.request({ method: 'DELETE', path, query, headers, body, options: params.options })
            .then(response => response.body);
    }
    /**
    * Delete an account access policy statement
    * @summary Delete an account access policy statement
    * @param {string} accountId Account ID
    * @param {string} policyId Policy ID
    * @param {string} statementId Statement ID
    * @throws {RequiredError}
    */
    deleteAccountAccessPolicyStatement(params) {
        // verify required parameter 'accountId' is not null or undefined
        if (params.accountId === null || params.accountId === undefined) {
            throw new utils_1.RequiredError('accountId', 'Required parameter accountId was null or undefined when calling deleteAccountAccessPolicyStatement.');
        }
        // verify required parameter 'policyId' is not null or undefined
        if (params.policyId === null || params.policyId === undefined) {
            throw new utils_1.RequiredError('policyId', 'Required parameter policyId was null or undefined when calling deleteAccountAccessPolicyStatement.');
        }
        // verify required parameter 'statementId' is not null or undefined
        if (params.statementId === null || params.statementId === undefined) {
            throw new utils_1.RequiredError('statementId', 'Required parameter statementId was null or undefined when calling deleteAccountAccessPolicyStatement.');
        }
        const path = `/accounts/{accountId}/policies/{policyId}/statements/{statementId}`
            .replace(`{${'accountId'}}`, String(params.accountId))
            .replace(`{${'policyId'}}`, String(params.policyId))
            .replace(`{${'statementId'}}`, String(params.statementId));
        const headers = {};
        const query = {};
        let body = null;
        return this.serviceRequester.request({ method: 'DELETE', path, query, headers, body, options: params.options })
            .then(response => response.body);
    }
    /**
    * Get all the account access policies
    * @summary Get all the account access policies
    * @param {string} accountId Account ID
    * @param {number} [$Top] Number of items to include
    * @param {string} [$SkipToken] Use skipToken for the next scroll
    * @throws {RequiredError}
    */
    getAccountAccessPolicies(params) {
        // verify required parameter 'accountId' is not null or undefined
        if (params.accountId === null || params.accountId === undefined) {
            throw new utils_1.RequiredError('accountId', 'Required parameter accountId was null or undefined when calling getAccountAccessPolicies.');
        }
        const path = `/accounts/{accountId}/policies`
            .replace(`{${'accountId'}}`, String(params.accountId));
        const headers = {};
        const query = {};
        let body = null;
        if (params.$Top !== undefined) {
            query['$top'] = params.$Top;
        }
        if (params.$SkipToken !== undefined) {
            query['$skipToken'] = params.$SkipToken;
        }
        return this.serviceRequester.request({ method: 'GET', path, query, headers, body, options: params.options })
            .then(response => response.body);
    }
    /**
    * Get an account access policy
    * @summary Get an account access policy
    * @param {string} accountId Account ID
    * @param {string} policyId Policy ID
    * @throws {RequiredError}
    */
    getAccountAccessPolicy(params) {
        // verify required parameter 'accountId' is not null or undefined
        if (params.accountId === null || params.accountId === undefined) {
            throw new utils_1.RequiredError('accountId', 'Required parameter accountId was null or undefined when calling getAccountAccessPolicy.');
        }
        // verify required parameter 'policyId' is not null or undefined
        if (params.policyId === null || params.policyId === undefined) {
            throw new utils_1.RequiredError('policyId', 'Required parameter policyId was null or undefined when calling getAccountAccessPolicy.');
        }
        const path = `/accounts/{accountId}/policies/{policyId}`
            .replace(`{${'accountId'}}`, String(params.accountId))
            .replace(`{${'policyId'}}`, String(params.policyId));
        const headers = {};
        const query = {};
        let body = null;
        return this.serviceRequester.request({ method: 'GET', path, query, headers, body, options: params.options })
            .then(response => response.body);
    }
    /**
    * Update an account access policy
    * @summary Update an account access policy
    * @param {string} accountId Account ID
    * @param {string} policyId Policy ID
    * @param {PolicyPutRequest} body
    * @throws {RequiredError}
    */
    updateAccountAccessPolicy(params) {
        // verify required parameter 'accountId' is not null or undefined
        if (params.accountId === null || params.accountId === undefined) {
            throw new utils_1.RequiredError('accountId', 'Required parameter accountId was null or undefined when calling updateAccountAccessPolicy.');
        }
        // verify required parameter 'policyId' is not null or undefined
        if (params.policyId === null || params.policyId === undefined) {
            throw new utils_1.RequiredError('policyId', 'Required parameter policyId was null or undefined when calling updateAccountAccessPolicy.');
        }
        // verify required parameter 'body' is not null or undefined
        if (params.body === null || params.body === undefined) {
            throw new utils_1.RequiredError('body', 'Required parameter body was null or undefined when calling updateAccountAccessPolicy.');
        }
        const path = `/accounts/{accountId}/policies/{policyId}`
            .replace(`{${'accountId'}}`, String(params.accountId))
            .replace(`{${'policyId'}}`, String(params.policyId));
        const headers = {};
        const query = {};
        let body = null;
        body = params.body || {};
        return this.serviceRequester.request({ method: 'PUT', path, query, headers, body, options: params.options })
            .then(response => response.body);
    }
    /**
    * Update an account access policy, adding a new policy statement
    * @summary Update an account access policy, adding a new policy statement
    * @param {string} accountId Account ID
    * @param {string} policyId Policy ID
    * @param {Statement} body
    * @throws {RequiredError}
    */
    updateAccountAccessPolicyStatement(params) {
        // verify required parameter 'accountId' is not null or undefined
        if (params.accountId === null || params.accountId === undefined) {
            throw new utils_1.RequiredError('accountId', 'Required parameter accountId was null or undefined when calling updateAccountAccessPolicyStatement.');
        }
        // verify required parameter 'policyId' is not null or undefined
        if (params.policyId === null || params.policyId === undefined) {
            throw new utils_1.RequiredError('policyId', 'Required parameter policyId was null or undefined when calling updateAccountAccessPolicyStatement.');
        }
        // verify required parameter 'body' is not null or undefined
        if (params.body === null || params.body === undefined) {
            throw new utils_1.RequiredError('body', 'Required parameter body was null or undefined when calling updateAccountAccessPolicyStatement.');
        }
        const path = `/accounts/{accountId}/policies/{policyId}/statements`
            .replace(`{${'accountId'}}`, String(params.accountId))
            .replace(`{${'policyId'}}`, String(params.policyId));
        const headers = {};
        const query = {};
        let body = null;
        body = params.body || {};
        return this.serviceRequester.request({ method: 'POST', path, query, headers, body, options: params.options })
            .then(response => response.body);
    }
    /**
    * Creates a new policy control.
    * @summary Create a Policy Control
    * @param {PolicyControlPostRequest} body
    * @throws {RequiredError}
    */
    createPolicyControl(params) {
        // verify required parameter 'body' is not null or undefined
        if (params.body === null || params.body === undefined) {
            throw new utils_1.RequiredError('body', 'Required parameter body was null or undefined when calling createPolicyControl.');
        }
        const path = `/policy-controls`;
        const headers = {};
        const query = {};
        let body = null;
        body = params.body || {};
        return this.serviceRequester.request({ method: 'POST', path, query, headers, body, options: params.options })
            .then(response => response.body);
    }
    /**
    * Delete policy control with policyControlId.
    * @summary Delete a Policy Control
    * @param {string} policyControlId Policy Control ID
    * @throws {RequiredError}
    */
    deletePolicyControl(params) {
        // verify required parameter 'policyControlId' is not null or undefined
        if (params.policyControlId === null || params.policyControlId === undefined) {
            throw new utils_1.RequiredError('policyControlId', 'Required parameter policyControlId was null or undefined when calling deletePolicyControl.');
        }
        const path = `/policy-controls/{policyControlId}`
            .replace(`{${'policyControlId'}}`, String(params.policyControlId));
        const headers = {};
        const query = {};
        let body = null;
        return this.serviceRequester.request({ method: 'DELETE', path, query, headers, body, options: params.options })
            .then(response => response.body);
    }
    /**
    * Retrieve policy control with policyControlId.
    * @summary Get a Policy Control
    * @param {string} policyControlId Policy Control ID
    * @throws {RequiredError}
    */
    getPolicyControl(params) {
        // verify required parameter 'policyControlId' is not null or undefined
        if (params.policyControlId === null || params.policyControlId === undefined) {
            throw new utils_1.RequiredError('policyControlId', 'Required parameter policyControlId was null or undefined when calling getPolicyControl.');
        }
        const path = `/policy-controls/{policyControlId}`
            .replace(`{${'policyControlId'}}`, String(params.policyControlId));
        const headers = {};
        const query = {};
        let body = null;
        return this.serviceRequester.request({ method: 'GET', path, query, headers, body, options: params.options })
            .then(response => response.body);
    }
    /**
    * Retrieve all policy controls.
    * @summary Get Policy Controls
    * @throws {RequiredError}
    */
    getPolicyControls(params) {
        const path = `/policy-controls`;
        const headers = {};
        const query = {};
        let body = null;
        return this.serviceRequester.request({ method: 'GET', path, query, headers, body, options: params.options })
            .then(response => response.body);
    }
    /**
    * Update policy control with policyControlId
    * @summary Update a Policy Control
    * @param {string} policyControlId Policy Control ID
    * @param {PolicyControlPutRequest} body
    * @throws {RequiredError}
    */
    updatePolicyControl(params) {
        // verify required parameter 'policyControlId' is not null or undefined
        if (params.policyControlId === null || params.policyControlId === undefined) {
            throw new utils_1.RequiredError('policyControlId', 'Required parameter policyControlId was null or undefined when calling updatePolicyControl.');
        }
        // verify required parameter 'body' is not null or undefined
        if (params.body === null || params.body === undefined) {
            throw new utils_1.RequiredError('body', 'Required parameter body was null or undefined when calling updatePolicyControl.');
        }
        const path = `/policy-controls/{policyControlId}`
            .replace(`{${'policyControlId'}}`, String(params.policyControlId));
        const headers = {};
        const query = {};
        let body = null;
        body = params.body || {};
        return this.serviceRequester.request({ method: 'PUT', path, query, headers, body, options: params.options })
            .then(response => response.body);
    }
    /**
    * Creates a new Scim Key, returns the key and the Base URL.
    * @summary create a secret key for Scim provisioing
    * @param {string} accountId Account ID
    * @param {ScimKeyPostRequest} body
    * @throws {RequiredError}
    */
    createScimKey(params) {
        // verify required parameter 'accountId' is not null or undefined
        if (params.accountId === null || params.accountId === undefined) {
            throw new utils_1.RequiredError('accountId', 'Required parameter accountId was null or undefined when calling createScimKey.');
        }
        // verify required parameter 'body' is not null or undefined
        if (params.body === null || params.body === undefined) {
            throw new utils_1.RequiredError('body', 'Required parameter body was null or undefined when calling createScimKey.');
        }
        const path = `/accounts/{accountId}/scimkey`
            .replace(`{${'accountId'}}`, String(params.accountId));
        const headers = {};
        const query = {};
        let body = null;
        body = params.body || {};
        return this.serviceRequester.request({ method: 'POST', path, query, headers, body, options: params.options })
            .then(response => response.body);
    }
    /**
    * Deletes a Scim Key from an account.
    * @summary removes the secret key from an account to disable Scim integration
    * @param {string} accountId Account ID
    * @throws {RequiredError}
    */
    deleteScimKey(params) {
        // verify required parameter 'accountId' is not null or undefined
        if (params.accountId === null || params.accountId === undefined) {
            throw new utils_1.RequiredError('accountId', 'Required parameter accountId was null or undefined when calling deleteScimKey.');
        }
        const path = `/accounts/{accountId}/scimkey`
            .replace(`{${'accountId'}}`, String(params.accountId));
        const headers = {};
        const query = {};
        let body = null;
        return this.serviceRequester.request({ method: 'DELETE', path, query, headers, body, options: params.options })
            .then(response => response.body);
    }
    /**
    * Determine whether the scim key was created or not for the account.
    * @summary Determine whether the scim key was created.
    * @param {string} accountId Account ID
    * @throws {RequiredError}
    */
    scimKeyExists(params) {
        // verify required parameter 'accountId' is not null or undefined
        if (params.accountId === null || params.accountId === undefined) {
            throw new utils_1.RequiredError('accountId', 'Required parameter accountId was null or undefined when calling scimKeyExists.');
        }
        const path = `/accounts/{accountId}/scimkey`
            .replace(`{${'accountId'}}`, String(params.accountId));
        const headers = {};
        const query = {};
        let body = null;
        return this.serviceRequester.request({ method: 'HEAD', path, query, headers, body, options: params.options })
            .then(response => response.body);
    }
    /**
    * Provides sso login functionality for the Cloudlink Gateway Portal through Mitel Connect for partners, called by Mitel Connect.
    * @summary Provides sso login for Gateways
    * @param {string} userId User Id provided by Mitel Connect
    * @param {string} sessionId Session Id provided by Mitel Connect
    * @throws {RequiredError}
    */
    ssoLogin(params) {
        // verify required parameter 'userId' is not null or undefined
        if (params.userId === null || params.userId === undefined) {
            throw new utils_1.RequiredError('userId', 'Required parameter userId was null or undefined when calling ssoLogin.');
        }
        // verify required parameter 'sessionId' is not null or undefined
        if (params.sessionId === null || params.sessionId === undefined) {
            throw new utils_1.RequiredError('sessionId', 'Required parameter sessionId was null or undefined when calling ssoLogin.');
        }
        const path = `/partners/sso-login`;
        const headers = {};
        const query = {};
        let body = null;
        const formParams = new URLSearchParams();
        if (params.userId !== undefined) {
            formParams.set('userId', params.userId);
        }
        if (params.sessionId !== undefined) {
            formParams.set('sessionId', params.sessionId);
        }
        headers['content-type'] = 'application/x-www-form-urlencoded';
        body = formParams.toString();
        return this.serviceRequester.request({ method: 'POST', path, query, headers, body, options: params.options })
            .then(response => response.body);
    }
    /**
    * Retreive registered services
    * @summary Get registered services
    * @param {string} accountId Account ID
    * @throws {RequiredError}
    */
    getServices(params) {
        // verify required parameter 'accountId' is not null or undefined
        if (params.accountId === null || params.accountId === undefined) {
            throw new utils_1.RequiredError('accountId', 'Required parameter accountId was null or undefined when calling getServices.');
        }
        const path = `/accounts/{accountId}/services`
            .replace(`{${'accountId'}}`, String(params.accountId));
        const headers = {};
        const query = {};
        let body = null;
        return this.serviceRequester.request({ method: 'GET', path, query, headers, body, options: params.options })
            .then(response => response.body);
    }
    /**
    * Add a site
    * @summary Add site
    * @param {string} accountId Account ID
    * @param {SitePostRequest} body
    * @throws {RequiredError}
    */
    createSite(params) {
        // verify required parameter 'accountId' is not null or undefined
        if (params.accountId === null || params.accountId === undefined) {
            throw new utils_1.RequiredError('accountId', 'Required parameter accountId was null or undefined when calling createSite.');
        }
        // verify required parameter 'body' is not null or undefined
        if (params.body === null || params.body === undefined) {
            throw new utils_1.RequiredError('body', 'Required parameter body was null or undefined when calling createSite.');
        }
        const path = `/accounts/{accountId}/sites`
            .replace(`{${'accountId'}}`, String(params.accountId));
        const headers = {};
        const query = {};
        let body = null;
        body = params.body || {};
        return this.serviceRequester.request({ method: 'POST', path, query, headers, body, options: params.options })
            .then(response => response.body);
    }
    /**
    * Delete a site
    * @summary Delete a site
    * @param {string} accountId Account ID
    * @param {string} siteId Site ID
    * @throws {RequiredError}
    */
    deleteSite(params) {
        // verify required parameter 'accountId' is not null or undefined
        if (params.accountId === null || params.accountId === undefined) {
            throw new utils_1.RequiredError('accountId', 'Required parameter accountId was null or undefined when calling deleteSite.');
        }
        // verify required parameter 'siteId' is not null or undefined
        if (params.siteId === null || params.siteId === undefined) {
            throw new utils_1.RequiredError('siteId', 'Required parameter siteId was null or undefined when calling deleteSite.');
        }
        const path = `/accounts/{accountId}/sites/{siteId}`
            .replace(`{${'accountId'}}`, String(params.accountId))
            .replace(`{${'siteId'}}`, String(params.siteId));
        const headers = {};
        const query = {};
        let body = null;
        return this.serviceRequester.request({ method: 'DELETE', path, query, headers, body, options: params.options })
            .then(response => response.body);
    }
    /**
    * Get a site by its ID
    * @summary Get a site
    * @param {string} accountId Account ID
    * @param {string} siteId Site ID
    * @param {string} [$Expand] expands an attribute
    * @throws {RequiredError}
    */
    getSite(params) {
        // verify required parameter 'accountId' is not null or undefined
        if (params.accountId === null || params.accountId === undefined) {
            throw new utils_1.RequiredError('accountId', 'Required parameter accountId was null or undefined when calling getSite.');
        }
        // verify required parameter 'siteId' is not null or undefined
        if (params.siteId === null || params.siteId === undefined) {
            throw new utils_1.RequiredError('siteId', 'Required parameter siteId was null or undefined when calling getSite.');
        }
        const path = `/accounts/{accountId}/sites/{siteId}`
            .replace(`{${'accountId'}}`, String(params.accountId))
            .replace(`{${'siteId'}}`, String(params.siteId));
        const headers = {};
        const query = {};
        let body = null;
        if (params.$Expand !== undefined) {
            query['$expand'] = params.$Expand;
        }
        return this.serviceRequester.request({ method: 'GET', path, query, headers, body, options: params.options })
            .then(response => response.body);
    }
    /**
    * Retreive sites for this account
    * @summary Get sites
    * @param {string} accountId Account ID
    * @param {number} [$Top] Number of items to include
    * @param {number} [$Skip] Number of items to skip
    * @param {string} [$Expand] expands an attribute
    * @param {string} [$SkipToken] Use skipToken for the next scroll
    * @throws {RequiredError}
    */
    getSites(params) {
        // verify required parameter 'accountId' is not null or undefined
        if (params.accountId === null || params.accountId === undefined) {
            throw new utils_1.RequiredError('accountId', 'Required parameter accountId was null or undefined when calling getSites.');
        }
        const path = `/accounts/{accountId}/sites`
            .replace(`{${'accountId'}}`, String(params.accountId));
        const headers = {};
        const query = {};
        let body = null;
        if (params.$Top !== undefined) {
            query['$top'] = params.$Top;
        }
        if (params.$Skip !== undefined) {
            query['$skip'] = params.$Skip;
        }
        if (params.$Expand !== undefined) {
            query['$expand'] = params.$Expand;
        }
        if (params.$SkipToken !== undefined) {
            query['$skipToken'] = params.$SkipToken;
        }
        return this.serviceRequester.request({ method: 'GET', path, query, headers, body, options: params.options })
            .then(response => response.body);
    }
    /**
    * Resync PBX data
    * @summary Resync
    * @param {ResyncRequest} [body]
    * @throws {RequiredError}
    */
    startResync(params) {
        const path = `/resync`;
        const headers = {};
        const query = {};
        let body = null;
        body = params.body || {};
        return this.serviceRequester.request({ method: 'PUT', path, query, headers, body, options: params.options })
            .then(response => response.body);
    }
    /**
    * Resync PBX data
    * @summary Resync
    * @param {string} accountId Account ID
    * @param {ResyncRequest} [body]
    * @throws {RequiredError}
    */
    startResyncByAccountId(params) {
        // verify required parameter 'accountId' is not null or undefined
        if (params.accountId === null || params.accountId === undefined) {
            throw new utils_1.RequiredError('accountId', 'Required parameter accountId was null or undefined when calling startResyncByAccountId.');
        }
        const path = `/accounts/{accountId}/resync`
            .replace(`{${'accountId'}}`, String(params.accountId));
        const headers = {};
        const query = {};
        let body = null;
        body = params.body || {};
        return this.serviceRequester.request({ method: 'PUT', path, query, headers, body, options: params.options })
            .then(response => response.body);
    }
    /**
    * Update a site with specific site configuration data
    * @summary Update site
    * @param {string} accountId Account ID
    * @param {string} siteId Site ID
    * @param {SitePutRequest} body
    * @throws {RequiredError}
    */
    updateSite(params) {
        // verify required parameter 'accountId' is not null or undefined
        if (params.accountId === null || params.accountId === undefined) {
            throw new utils_1.RequiredError('accountId', 'Required parameter accountId was null or undefined when calling updateSite.');
        }
        // verify required parameter 'siteId' is not null or undefined
        if (params.siteId === null || params.siteId === undefined) {
            throw new utils_1.RequiredError('siteId', 'Required parameter siteId was null or undefined when calling updateSite.');
        }
        // verify required parameter 'body' is not null or undefined
        if (params.body === null || params.body === undefined) {
            throw new utils_1.RequiredError('body', 'Required parameter body was null or undefined when calling updateSite.');
        }
        const path = `/accounts/{accountId}/sites/{siteId}`
            .replace(`{${'accountId'}}`, String(params.accountId))
            .replace(`{${'siteId'}}`, String(params.siteId));
        const headers = {};
        const query = {};
        let body = null;
        body = params.body || {};
        return this.serviceRequester.request({ method: 'PUT', path, query, headers, body, options: params.options })
            .then(response => response.body);
    }
    /**
    * Retrieve the specification in swagger format for this api
    * @summary Get spec
    * @throws {RequiredError}
    */
    getSpec(params) {
        const path = `/_spec`;
        const headers = {};
        const query = {};
        let body = null;
        return this.serviceRequester.request({ method: 'GET', path, query, headers, body, options: params.options })
            .then(response => response.body);
    }
    /**
    * Provides the status of the microservice
    * @summary Get microservice status
    * @throws {RequiredError}
    */
    getStatus(params) {
        const path = `/_status`;
        const headers = {};
        const query = {};
        let body = null;
        return this.serviceRequester.request({ method: 'GET', path, query, headers, body, options: params.options })
            .then(response => response.body);
    }
    /**
    * Creates a new User.   No Authorization is needed.
    * @summary Create a User
    * @param {UserPostRequest} body
    * @throws {RequiredError}
    */
    createUser(params) {
        // verify required parameter 'body' is not null or undefined
        if (params.body === null || params.body === undefined) {
            throw new utils_1.RequiredError('body', 'Required parameter body was null or undefined when calling createUser.');
        }
        const path = `/users`;
        const headers = {};
        const query = {};
        let body = null;
        body = params.body || {};
        return this.serviceRequester.request({ method: 'POST', path, query, headers, body, options: params.options })
            .then(response => response.body);
    }
    /**
    * Creates a new User using the account Id in the path.
    * @summary Create a User in Account
    * @param {string} accountId Account ID
    * @param {BaseUserPostRequest} body
    * @throws {RequiredError}
    */
    createUserByAccountId(params) {
        // verify required parameter 'accountId' is not null or undefined
        if (params.accountId === null || params.accountId === undefined) {
            throw new utils_1.RequiredError('accountId', 'Required parameter accountId was null or undefined when calling createUserByAccountId.');
        }
        // verify required parameter 'body' is not null or undefined
        if (params.body === null || params.body === undefined) {
            throw new utils_1.RequiredError('body', 'Required parameter body was null or undefined when calling createUserByAccountId.');
        }
        const path = `/accounts/{accountId}/users`
            .replace(`{${'accountId'}}`, String(params.accountId));
        const headers = {};
        const query = {};
        let body = null;
        body = params.body || {};
        return this.serviceRequester.request({ method: 'POST', path, query, headers, body, options: params.options })
            .then(response => response.body);
    }
    /**
    * Creates a new tag for the user.   If tagId already exist it will overwrite.
    * @summary Create a tag
    * @param {string} userId User ID
    * @param {TagPostRequest} body
    * @throws {RequiredError}
    */
    createUserTag(params) {
        // verify required parameter 'userId' is not null or undefined
        if (params.userId === null || params.userId === undefined) {
            throw new utils_1.RequiredError('userId', 'Required parameter userId was null or undefined when calling createUserTag.');
        }
        // verify required parameter 'body' is not null or undefined
        if (params.body === null || params.body === undefined) {
            throw new utils_1.RequiredError('body', 'Required parameter body was null or undefined when calling createUserTag.');
        }
        const path = `/users/{userId}/tags`
            .replace(`{${'userId'}}`, String(params.userId));
        const headers = {};
        const query = {};
        let body = null;
        body = params.body || {};
        return this.serviceRequester.request({ method: 'POST', path, query, headers, body, options: params.options })
            .then(response => response.body);
    }
    /**
    * Creates a new tag for the user.   If tagId already exist it will overwrite.
    * @summary Create a User Tag by Account
    * @param {string} accountId Account ID
    * @param {string} userId User ID
    * @param {TagPostRequest} body
    * @throws {RequiredError}
    */
    createUserTagByAccountId(params) {
        // verify required parameter 'accountId' is not null or undefined
        if (params.accountId === null || params.accountId === undefined) {
            throw new utils_1.RequiredError('accountId', 'Required parameter accountId was null or undefined when calling createUserTagByAccountId.');
        }
        // verify required parameter 'userId' is not null or undefined
        if (params.userId === null || params.userId === undefined) {
            throw new utils_1.RequiredError('userId', 'Required parameter userId was null or undefined when calling createUserTagByAccountId.');
        }
        // verify required parameter 'body' is not null or undefined
        if (params.body === null || params.body === undefined) {
            throw new utils_1.RequiredError('body', 'Required parameter body was null or undefined when calling createUserTagByAccountId.');
        }
        const path = `/accounts/{accountId}/users/{userId}/tags`
            .replace(`{${'accountId'}}`, String(params.accountId))
            .replace(`{${'userId'}}`, String(params.userId));
        const headers = {};
        const query = {};
        let body = null;
        body = params.body || {};
        return this.serviceRequester.request({ method: 'POST', path, query, headers, body, options: params.options })
            .then(response => response.body);
    }
    /**
    * Delete user with userId(email, userId or mobile number) if the token has role of `GLOBAL_ADMIN`, `PARTNER_ADMIN` or `ACCOUNT_ADMIN`.
    * @summary Delete a User
    * @param {string} userId User ID
    * @throws {RequiredError}
    */
    deleteUser(params) {
        // verify required parameter 'userId' is not null or undefined
        if (params.userId === null || params.userId === undefined) {
            throw new utils_1.RequiredError('userId', 'Required parameter userId was null or undefined when calling deleteUser.');
        }
        const path = `/users/{userId}`
            .replace(`{${'userId'}}`, String(params.userId));
        const headers = {};
        const query = {};
        let body = null;
        return this.serviceRequester.request({ method: 'DELETE', path, query, headers, body, options: params.options })
            .then(response => response.body);
    }
    /**
    * Delete user with userId(email, userId or mobile number) if the token has role of `GLOBAL_ADMIN`, `PARTNER_ADMIN` or `ACCOUNT_ADMIN`.
    * @summary Delete a User by Account
    * @param {string} accountId Account ID
    * @param {string} userId User ID
    * @throws {RequiredError}
    */
    deleteUserByAccountId(params) {
        // verify required parameter 'accountId' is not null or undefined
        if (params.accountId === null || params.accountId === undefined) {
            throw new utils_1.RequiredError('accountId', 'Required parameter accountId was null or undefined when calling deleteUserByAccountId.');
        }
        // verify required parameter 'userId' is not null or undefined
        if (params.userId === null || params.userId === undefined) {
            throw new utils_1.RequiredError('userId', 'Required parameter userId was null or undefined when calling deleteUserByAccountId.');
        }
        const path = `/accounts/{accountId}/users/{userId}`
            .replace(`{${'accountId'}}`, String(params.accountId))
            .replace(`{${'userId'}}`, String(params.userId));
        const headers = {};
        const query = {};
        let body = null;
        return this.serviceRequester.request({ method: 'DELETE', path, query, headers, body, options: params.options })
            .then(response => response.body);
    }
    /**
    * Delete tag with tagId of a user with userId(email, userId or mobile number)   If the token has role of `USER` they will not be able to modify other users.
    * @summary Delete a User tag
    * @param {string} userId User ID
    * @param {string} tagId Tag ID
    * @throws {RequiredError}
    */
    deleteUserTag(params) {
        // verify required parameter 'userId' is not null or undefined
        if (params.userId === null || params.userId === undefined) {
            throw new utils_1.RequiredError('userId', 'Required parameter userId was null or undefined when calling deleteUserTag.');
        }
        // verify required parameter 'tagId' is not null or undefined
        if (params.tagId === null || params.tagId === undefined) {
            throw new utils_1.RequiredError('tagId', 'Required parameter tagId was null or undefined when calling deleteUserTag.');
        }
        const path = `/users/{userId}/tags/{tagId}`
            .replace(`{${'userId'}}`, String(params.userId))
            .replace(`{${'tagId'}}`, String(params.tagId));
        const headers = {};
        const query = {};
        let body = null;
        return this.serviceRequester.request({ method: 'DELETE', path, query, headers, body, options: params.options })
            .then(response => response.body);
    }
    /**
    * Delete tag with tagId of a user with userId(email, userId or mobile number)   If the token has role of `USER` they will not be able to modify other users.
    * @summary Delete a User tag by Account
    * @param {string} accountId Account ID
    * @param {string} userId User ID
    * @param {string} tagId Tag ID
    * @throws {RequiredError}
    */
    deleteUserTagByAccountId(params) {
        // verify required parameter 'accountId' is not null or undefined
        if (params.accountId === null || params.accountId === undefined) {
            throw new utils_1.RequiredError('accountId', 'Required parameter accountId was null or undefined when calling deleteUserTagByAccountId.');
        }
        // verify required parameter 'userId' is not null or undefined
        if (params.userId === null || params.userId === undefined) {
            throw new utils_1.RequiredError('userId', 'Required parameter userId was null or undefined when calling deleteUserTagByAccountId.');
        }
        // verify required parameter 'tagId' is not null or undefined
        if (params.tagId === null || params.tagId === undefined) {
            throw new utils_1.RequiredError('tagId', 'Required parameter tagId was null or undefined when calling deleteUserTagByAccountId.');
        }
        const path = `/accounts/{accountId}/users/{userId}/tags/{tagId}`
            .replace(`{${'accountId'}}`, String(params.accountId))
            .replace(`{${'userId'}}`, String(params.userId))
            .replace(`{${'tagId'}}`, String(params.tagId));
        const headers = {};
        const query = {};
        let body = null;
        return this.serviceRequester.request({ method: 'DELETE', path, query, headers, body, options: params.options })
            .then(response => response.body);
    }
    /**
    * Retrieve user with userId(email, userId or mobile number) if the token has role of `GLOBAL_ADMIN`, `PARTNER_ADMIN` or `ACCOUNT_ADMIN`.
    * @summary Get a User
    * @param {string} userId User ID
    * @param {string} [$Expand] expands an attribute
    * @throws {RequiredError}
    */
    getUser(params) {
        // verify required parameter 'userId' is not null or undefined
        if (params.userId === null || params.userId === undefined) {
            throw new utils_1.RequiredError('userId', 'Required parameter userId was null or undefined when calling getUser.');
        }
        const path = `/users/{userId}`
            .replace(`{${'userId'}}`, String(params.userId));
        const headers = {};
        const query = {};
        let body = null;
        if (params.$Expand !== undefined) {
            query['$expand'] = params.$Expand;
        }
        return this.serviceRequester.request({ method: 'GET', path, query, headers, body, options: params.options })
            .then(response => response.body);
    }
    /**
    * Retrieve user with userId(email, userId or mobile number) if the token has role of `GLOBAL_ADMIN`, `PARTNER_ADMIN` or `ACCOUNT_ADMIN`.
    * @summary Get a User by Account
    * @param {string} accountId Account ID
    * @param {string} userId User ID
    * @param {string} [$Expand] expands an attribute
    * @throws {RequiredError}
    */
    getUserByAccountId(params) {
        // verify required parameter 'accountId' is not null or undefined
        if (params.accountId === null || params.accountId === undefined) {
            throw new utils_1.RequiredError('accountId', 'Required parameter accountId was null or undefined when calling getUserByAccountId.');
        }
        // verify required parameter 'userId' is not null or undefined
        if (params.userId === null || params.userId === undefined) {
            throw new utils_1.RequiredError('userId', 'Required parameter userId was null or undefined when calling getUserByAccountId.');
        }
        const path = `/accounts/{accountId}/users/{userId}`
            .replace(`{${'accountId'}}`, String(params.accountId))
            .replace(`{${'userId'}}`, String(params.userId));
        const headers = {};
        const query = {};
        let body = null;
        if (params.$Expand !== undefined) {
            query['$expand'] = params.$Expand;
        }
        return this.serviceRequester.request({ method: 'GET', path, query, headers, body, options: params.options })
            .then(response => response.body);
    }
    /**
    * Retrieve tags with tagId of user with userId(email, userId or mobile number)
    * @summary Get a User tag with tagId
    * @param {string} userId User ID
    * @param {string} tagId Tag ID
    * @throws {RequiredError}
    */
    getUserTag(params) {
        // verify required parameter 'userId' is not null or undefined
        if (params.userId === null || params.userId === undefined) {
            throw new utils_1.RequiredError('userId', 'Required parameter userId was null or undefined when calling getUserTag.');
        }
        // verify required parameter 'tagId' is not null or undefined
        if (params.tagId === null || params.tagId === undefined) {
            throw new utils_1.RequiredError('tagId', 'Required parameter tagId was null or undefined when calling getUserTag.');
        }
        const path = `/users/{userId}/tags/{tagId}`
            .replace(`{${'userId'}}`, String(params.userId))
            .replace(`{${'tagId'}}`, String(params.tagId));
        const headers = {};
        const query = {};
        let body = null;
        return this.serviceRequester.request({ method: 'GET', path, query, headers, body, options: params.options })
            .then(response => response.body);
    }
    /**
    * Retrieve tags with tagId of user with userId(email, userId or mobile number)
    * @summary Get a User Tag with tagId
    * @param {string} accountId Account ID
    * @param {string} userId User ID
    * @param {string} tagId Tag ID
    * @throws {RequiredError}
    */
    getUserTagByAccountId(params) {
        // verify required parameter 'accountId' is not null or undefined
        if (params.accountId === null || params.accountId === undefined) {
            throw new utils_1.RequiredError('accountId', 'Required parameter accountId was null or undefined when calling getUserTagByAccountId.');
        }
        // verify required parameter 'userId' is not null or undefined
        if (params.userId === null || params.userId === undefined) {
            throw new utils_1.RequiredError('userId', 'Required parameter userId was null or undefined when calling getUserTagByAccountId.');
        }
        // verify required parameter 'tagId' is not null or undefined
        if (params.tagId === null || params.tagId === undefined) {
            throw new utils_1.RequiredError('tagId', 'Required parameter tagId was null or undefined when calling getUserTagByAccountId.');
        }
        const path = `/accounts/{accountId}/users/{userId}/tags/{tagId}`
            .replace(`{${'accountId'}}`, String(params.accountId))
            .replace(`{${'userId'}}`, String(params.userId))
            .replace(`{${'tagId'}}`, String(params.tagId));
        const headers = {};
        const query = {};
        let body = null;
        return this.serviceRequester.request({ method: 'GET', path, query, headers, body, options: params.options })
            .then(response => response.body);
    }
    /**
    * Gets the tags set for the user
    * @summary Get tags of users
    * @param {string} userId User ID
    * @throws {RequiredError}
    */
    getUserTags(params) {
        // verify required parameter 'userId' is not null or undefined
        if (params.userId === null || params.userId === undefined) {
            throw new utils_1.RequiredError('userId', 'Required parameter userId was null or undefined when calling getUserTags.');
        }
        const path = `/users/{userId}/tags`
            .replace(`{${'userId'}}`, String(params.userId));
        const headers = {};
        const query = {};
        let body = null;
        return this.serviceRequester.request({ method: 'GET', path, query, headers, body, options: params.options })
            .then(response => response.body);
    }
    /**
    * Gets the tags set for the user
    * @summary Get Tags of Users by Account
    * @param {string} accountId Account ID
    * @param {string} userId User ID
    * @throws {RequiredError}
    */
    getUserTagsByAccountId(params) {
        // verify required parameter 'accountId' is not null or undefined
        if (params.accountId === null || params.accountId === undefined) {
            throw new utils_1.RequiredError('accountId', 'Required parameter accountId was null or undefined when calling getUserTagsByAccountId.');
        }
        // verify required parameter 'userId' is not null or undefined
        if (params.userId === null || params.userId === undefined) {
            throw new utils_1.RequiredError('userId', 'Required parameter userId was null or undefined when calling getUserTagsByAccountId.');
        }
        const path = `/accounts/{accountId}/users/{userId}/tags`
            .replace(`{${'accountId'}}`, String(params.accountId))
            .replace(`{${'userId'}}`, String(params.userId));
        const headers = {};
        const query = {};
        let body = null;
        return this.serviceRequester.request({ method: 'GET', path, query, headers, body, options: params.options })
            .then(response => response.body);
    }
    /**
    * Retrieve all users.  `GLOBAL_ADMIN` will get users in all accounts. `PARTNER_ADMIN` will get users in all accounts within partner. `ACCOUNT_ADMIN` and `USER` will get all users within account. Not supported for `GUEST`. Data is paged on the server and sorted by most recent partner first.
    * @summary Get Users
    * @param {number} [$Skip] Number of items to skip
    * @param {number} [$Top] Number of items to include
    * @param {string} [$SkipToken] Use skipToken for the next scroll
    * @param {string} [skipTokenTimeout] The time (in seconds) that the result will be scrollable
    * @param {string} [$Filter] Odata filter param
    * @param {string} [$Search] text based search
    * @param {string} [$SearchKeys] a comma-separated list of keys to search in, e.g. name, email, tags. Used in conjunction with $search.
    * @param {string} [$Expand] expands an attribute
    * @param {string} [items] a comma-separated list of items to get, e.g. user-id-1, user-id-2
    * @param {string} [itemKeys] a comma-separated list of keys to lookup matching items in, e.g. userId, loginId, used in conjunction with items
    * @param {string} [$Orderby] a comma-separated list of fields and order to sort on, e.g. role asc, loginId desc.  Defaults to ascending when no order is specified.
    * @throws {RequiredError}
    */
    getUsers(params) {
        const path = `/users`;
        const headers = {};
        const query = {};
        let body = null;
        if (params.$Skip !== undefined) {
            query['$skip'] = params.$Skip;
        }
        if (params.$Top !== undefined) {
            query['$top'] = params.$Top;
        }
        if (params.$SkipToken !== undefined) {
            query['$skipToken'] = params.$SkipToken;
        }
        if (params.skipTokenTimeout !== undefined) {
            query['skipTokenTimeout'] = params.skipTokenTimeout;
        }
        if (params.$Filter !== undefined) {
            query['$filter'] = params.$Filter;
        }
        if (params.$Search !== undefined) {
            query['$search'] = params.$Search;
        }
        if (params.$SearchKeys !== undefined) {
            query['$searchKeys'] = params.$SearchKeys;
        }
        if (params.$Expand !== undefined) {
            query['$expand'] = params.$Expand;
        }
        if (params.items !== undefined) {
            query['items'] = params.items;
        }
        if (params.itemKeys !== undefined) {
            query['itemKeys'] = params.itemKeys;
        }
        if (params.$Orderby !== undefined) {
            query['$orderby'] = params.$Orderby;
        }
        return this.serviceRequester.request({ method: 'GET', path, query, headers, body, options: params.options })
            .then(response => response.body);
    }
    /**
    * Retrieve all users.  `GLOBAL_ADMIN` will get users in all accounts. `PARTNER_ADMIN` will get users in all accounts within partner. `ACCOUNT_ADMIN` and `USER` will get all users within account. Not supported for `GUEST`.  Data is paged on the server and sorted by most recent partner first.
    * @summary Get Users by Account
    * @param {string} accountId Account ID
    * @param {number} [$Skip] Number of items to skip
    * @param {number} [$Top] Number of items to include
    * @param {string} [$SkipToken] Use skipToken for the next scroll
    * @param {string} [$Filter] Odata filter param
    * @param {string} [$Search] text based search
    * @param {string} [$SearchKeys] a comma-separated list of keys to search in, e.g. name, email, tags. Used in conjunction with $search.
    * @param {string} [$Expand] expands an attribute
    * @param {string} [items] a comma-separated list of items to get, e.g. user-id-1, user-id-2
    * @param {string} [itemKeys] a comma-separated list of keys to lookup matching items in, e.g. userId, loginId, used in conjunction with items
    * @param {string} [$Orderby] a comma-separated list of fields and order to sort on, e.g. role asc, loginId desc.  Defaults to ascending when no order is specified.
    * @throws {RequiredError}
    */
    getUsersByAccountId(params) {
        // verify required parameter 'accountId' is not null or undefined
        if (params.accountId === null || params.accountId === undefined) {
            throw new utils_1.RequiredError('accountId', 'Required parameter accountId was null or undefined when calling getUsersByAccountId.');
        }
        const path = `/accounts/{accountId}/users`
            .replace(`{${'accountId'}}`, String(params.accountId));
        const headers = {};
        const query = {};
        let body = null;
        if (params.$Skip !== undefined) {
            query['$skip'] = params.$Skip;
        }
        if (params.$Top !== undefined) {
            query['$top'] = params.$Top;
        }
        if (params.$SkipToken !== undefined) {
            query['$skipToken'] = params.$SkipToken;
        }
        if (params.$Filter !== undefined) {
            query['$filter'] = params.$Filter;
        }
        if (params.$Search !== undefined) {
            query['$search'] = params.$Search;
        }
        if (params.$SearchKeys !== undefined) {
            query['$searchKeys'] = params.$SearchKeys;
        }
        if (params.$Expand !== undefined) {
            query['$expand'] = params.$Expand;
        }
        if (params.items !== undefined) {
            query['items'] = params.items;
        }
        if (params.itemKeys !== undefined) {
            query['itemKeys'] = params.itemKeys;
        }
        if (params.$Orderby !== undefined) {
            query['$orderby'] = params.$Orderby;
        }
        return this.serviceRequester.request({ method: 'GET', path, query, headers, body, options: params.options })
            .then(response => response.body);
    }
    /**
    * Retrieve all users with tag of tagId expanded.  `GLOBAL_ADMIN` will get users in all accounts. `PARTNER_ADMIN` will get users in all accounts within partner. `ACCOUNT_ADMIN` and `USER` will get all users within account. Not supported for `GUEST`. Data is paged on the server and sorted by most recent partner first.
    * @summary Get Users with Tag tagId expanded
    * @param {string} tagId Tag ID
    * @param {number} [$Skip] Number of items to skip
    * @param {number} [$Top] Number of items to include
    * @param {string} [$SkipToken] Use skipToken for the next scroll
    * @param {string} [skipTokenTimeout] The time (in seconds) that the result will be scrollable
    * @param {string} [$Filter] Odata filter param
    * @param {string} [$Search] text based search
    * @param {string} [$SearchKeys] a comma-separated list of keys to search in, e.g. name, email, tags. Used in conjunction with $search.
    * @throws {RequiredError}
    */
    getUsersWithTag(params) {
        // verify required parameter 'tagId' is not null or undefined
        if (params.tagId === null || params.tagId === undefined) {
            throw new utils_1.RequiredError('tagId', 'Required parameter tagId was null or undefined when calling getUsersWithTag.');
        }
        const path = `/users/tags/{tagId}`
            .replace(`{${'tagId'}}`, String(params.tagId));
        const headers = {};
        const query = {};
        let body = null;
        if (params.$Skip !== undefined) {
            query['$skip'] = params.$Skip;
        }
        if (params.$Top !== undefined) {
            query['$top'] = params.$Top;
        }
        if (params.$SkipToken !== undefined) {
            query['$skipToken'] = params.$SkipToken;
        }
        if (params.skipTokenTimeout !== undefined) {
            query['skipTokenTimeout'] = params.skipTokenTimeout;
        }
        if (params.$Filter !== undefined) {
            query['$filter'] = params.$Filter;
        }
        if (params.$Search !== undefined) {
            query['$search'] = params.$Search;
        }
        if (params.$SearchKeys !== undefined) {
            query['$searchKeys'] = params.$SearchKeys;
        }
        return this.serviceRequester.request({ method: 'GET', path, query, headers, body, options: params.options })
            .then(response => response.body);
    }
    /**
    * Retrieve all users with tag of tagId expanded. .  `GLOBAL_ADMIN` will get users in all accounts. `PARTNER_ADMIN` will get users in all accounts within partner. `ACCOUNT_ADMIN` and `USER` will get all users within account. Not supported for `GUEST`. Data is paged on the server and sorted by most recent partner first.
    * @summary Get Users by Account With Tag expanded
    * @param {string} accountId Account ID
    * @param {string} tagId Tag ID
    * @param {number} [$Skip] Number of items to skip
    * @param {number} [$Top] Number of items to include
    * @param {string} [$SkipToken] Use skipToken for the next scroll
    * @param {string} [$Filter] Odata filter param
    * @param {string} [$Search] text based search
    * @param {string} [$SearchKeys] a comma-separated list of keys to search in, e.g. name, email, tags. Used in conjunction with $search.
    * @throws {RequiredError}
    */
    getUsersWithTagByAccountId(params) {
        // verify required parameter 'accountId' is not null or undefined
        if (params.accountId === null || params.accountId === undefined) {
            throw new utils_1.RequiredError('accountId', 'Required parameter accountId was null or undefined when calling getUsersWithTagByAccountId.');
        }
        // verify required parameter 'tagId' is not null or undefined
        if (params.tagId === null || params.tagId === undefined) {
            throw new utils_1.RequiredError('tagId', 'Required parameter tagId was null or undefined when calling getUsersWithTagByAccountId.');
        }
        const path = `/accounts/{accountId}/users/tags/{tagId}`
            .replace(`{${'accountId'}}`, String(params.accountId))
            .replace(`{${'tagId'}}`, String(params.tagId));
        const headers = {};
        const query = {};
        let body = null;
        if (params.$Skip !== undefined) {
            query['$skip'] = params.$Skip;
        }
        if (params.$Top !== undefined) {
            query['$top'] = params.$Top;
        }
        if (params.$SkipToken !== undefined) {
            query['$skipToken'] = params.$SkipToken;
        }
        if (params.$Filter !== undefined) {
            query['$filter'] = params.$Filter;
        }
        if (params.$Search !== undefined) {
            query['$search'] = params.$Search;
        }
        if (params.$SearchKeys !== undefined) {
            query['$searchKeys'] = params.$SearchKeys;
        }
        return this.serviceRequester.request({ method: 'GET', path, query, headers, body, options: params.options })
            .then(response => response.body);
    }
    /**
    * Retrieve all users with tags expanded.  `GLOBAL_ADMIN` will get users in all accounts. `PARTNER_ADMIN` will get users in all accounts within partner. `ACCOUNT_ADMIN` and `USER` will get all users within account. Not supported for `GUEST`. . Data is paged on the server and sorted by most recent partner first.
    * @summary Get Users with Tags expanded
    * @param {number} [$Skip] Number of items to skip
    * @param {number} [$Top] Number of items to include
    * @param {string} [$SkipToken] Use skipToken for the next scroll
    * @param {string} [skipTokenTimeout] The time (in seconds) that the result will be scrollable
    * @param {string} [$Filter] Odata filter param
    * @param {string} [$Search] text based search
    * @param {string} [$SearchKeys] a comma-separated list of keys to search in, e.g. name, email, tags. Used in conjunction with $search.
    * @throws {RequiredError}
    */
    getUsersWithTags(params) {
        const path = `/users/tags`;
        const headers = {};
        const query = {};
        let body = null;
        if (params.$Skip !== undefined) {
            query['$skip'] = params.$Skip;
        }
        if (params.$Top !== undefined) {
            query['$top'] = params.$Top;
        }
        if (params.$SkipToken !== undefined) {
            query['$skipToken'] = params.$SkipToken;
        }
        if (params.skipTokenTimeout !== undefined) {
            query['skipTokenTimeout'] = params.skipTokenTimeout;
        }
        if (params.$Filter !== undefined) {
            query['$filter'] = params.$Filter;
        }
        if (params.$Search !== undefined) {
            query['$search'] = params.$Search;
        }
        if (params.$SearchKeys !== undefined) {
            query['$searchKeys'] = params.$SearchKeys;
        }
        return this.serviceRequester.request({ method: 'GET', path, query, headers, body, options: params.options })
            .then(response => response.body);
    }
    /**
    * Retrieve all users with tags expanded..  `GLOBAL_ADMIN` will get users in all accounts. `PARTNER_ADMIN` will get users in all accounts within partner. `ACCOUNT_ADMIN` and `USER` will get all users within account. Not supported for `GUEST`. Data is paged on the server and sorted by most recent partner first.
    * @summary Get Users by Account with Tags expanded
    * @param {string} accountId Account ID
    * @param {number} [$Skip] Number of items to skip
    * @param {number} [$Top] Number of items to include
    * @param {string} [$SkipToken] Use skipToken for the next scroll
    * @param {string} [$Filter] Odata filter param
    * @param {string} [$Search] text based search
    * @param {string} [$SearchKeys] a comma-separated list of keys to search in, e.g. name, email, tags. Used in conjunction with $search.
    * @throws {RequiredError}
    */
    getUsersWithTagsByAccountId(params) {
        // verify required parameter 'accountId' is not null or undefined
        if (params.accountId === null || params.accountId === undefined) {
            throw new utils_1.RequiredError('accountId', 'Required parameter accountId was null or undefined when calling getUsersWithTagsByAccountId.');
        }
        const path = `/accounts/{accountId}/users/tags`
            .replace(`{${'accountId'}}`, String(params.accountId));
        const headers = {};
        const query = {};
        let body = null;
        if (params.$Skip !== undefined) {
            query['$skip'] = params.$Skip;
        }
        if (params.$Top !== undefined) {
            query['$top'] = params.$Top;
        }
        if (params.$SkipToken !== undefined) {
            query['$skipToken'] = params.$SkipToken;
        }
        if (params.$Filter !== undefined) {
            query['$filter'] = params.$Filter;
        }
        if (params.$Search !== undefined) {
            query['$search'] = params.$Search;
        }
        if (params.$SearchKeys !== undefined) {
            query['$searchKeys'] = params.$SearchKeys;
        }
        return this.serviceRequester.request({ method: 'GET', path, query, headers, body, options: params.options })
            .then(response => response.body);
    }
    /**
    * Batch of operations to create, update, delete multiple users in one request
    * @summary Patch users
    * @param {UserPatchRequest} body
    * @throws {RequiredError}
    */
    patchUsers(params) {
        // verify required parameter 'body' is not null or undefined
        if (params.body === null || params.body === undefined) {
            throw new utils_1.RequiredError('body', 'Required parameter body was null or undefined when calling patchUsers.');
        }
        const path = `/users`;
        const headers = {};
        const query = {};
        let body = null;
        body = params.body || {};
        return this.serviceRequester.request({ method: 'PATCH', path, query, headers, body, options: params.options })
            .then(response => response.body);
    }
    /**
    * Batch of operations to create, update, delete multiple users in one request
    * @summary Patch users in Account
    * @param {string} accountId Account ID
    * @param {UserPatchRequest} body
    * @throws {RequiredError}
    */
    patchUsersByAccountId(params) {
        // verify required parameter 'accountId' is not null or undefined
        if (params.accountId === null || params.accountId === undefined) {
            throw new utils_1.RequiredError('accountId', 'Required parameter accountId was null or undefined when calling patchUsersByAccountId.');
        }
        // verify required parameter 'body' is not null or undefined
        if (params.body === null || params.body === undefined) {
            throw new utils_1.RequiredError('body', 'Required parameter body was null or undefined when calling patchUsersByAccountId.');
        }
        const path = `/accounts/{accountId}/users`
            .replace(`{${'accountId'}}`, String(params.accountId));
        const headers = {};
        const query = {};
        let body = null;
        body = params.body || {};
        return this.serviceRequester.request({ method: 'PATCH', path, query, headers, body, options: params.options })
            .then(response => response.body);
    }
    /**
    * This is used to reset password.   If the action is `forgot` with an email address, then an email will be sent with a temporary access code to reset the password.   If the action is `reset`, this will set the new password provided if the provided temporary access code matches for the email address.   If the action is `change`, this will set the new password after validating the old password
    * @summary Change/Reset/Forgot Password for User
    * @param {string} userId User ID
    * @param {ResetUserPasswordRequest} body
    * @throws {RequiredError}
    */
    resetUserPassword(params) {
        // verify required parameter 'userId' is not null or undefined
        if (params.userId === null || params.userId === undefined) {
            throw new utils_1.RequiredError('userId', 'Required parameter userId was null or undefined when calling resetUserPassword.');
        }
        // verify required parameter 'body' is not null or undefined
        if (params.body === null || params.body === undefined) {
            throw new utils_1.RequiredError('body', 'Required parameter body was null or undefined when calling resetUserPassword.');
        }
        const path = `/users/{userId}/password`
            .replace(`{${'userId'}}`, String(params.userId));
        const headers = {};
        const query = {};
        let body = null;
        body = params.body || {};
        return this.serviceRequester.request({ method: 'PUT', path, query, headers, body, options: params.options })
            .then(response => response.body);
    }
    /**
    * Send a temporary accessCode to the user using the requested communication type.
    * @summary Send a temporary accessCode.
    * @param {string} userId User ID
    * @param {UserAccessCodePostRequest} body
    * @throws {RequiredError}
    */
    sendUserAccessCode(params) {
        // verify required parameter 'userId' is not null or undefined
        if (params.userId === null || params.userId === undefined) {
            throw new utils_1.RequiredError('userId', 'Required parameter userId was null or undefined when calling sendUserAccessCode.');
        }
        // verify required parameter 'body' is not null or undefined
        if (params.body === null || params.body === undefined) {
            throw new utils_1.RequiredError('body', 'Required parameter body was null or undefined when calling sendUserAccessCode.');
        }
        const path = `/users/{userId}/accessCode`
            .replace(`{${'userId'}}`, String(params.userId));
        const headers = {};
        const query = {};
        let body = null;
        body = params.body || {};
        return this.serviceRequester.request({ method: 'POST', path, query, headers, body, options: params.options })
            .then(response => response.body);
    }
    /**
    * Send a welcome email to the user. Valid for ACCOUNT_ADMIN role or higher.
    * @summary Send a welcome email by Account
    * @param {string} accountId Account ID
    * @param {string} email
    * @param {UserWelcomeEmailRequest} body
    * @throws {RequiredError}
    */
    sendWelcomeByAccountId(params) {
        // verify required parameter 'accountId' is not null or undefined
        if (params.accountId === null || params.accountId === undefined) {
            throw new utils_1.RequiredError('accountId', 'Required parameter accountId was null or undefined when calling sendWelcomeByAccountId.');
        }
        // verify required parameter 'email' is not null or undefined
        if (params.email === null || params.email === undefined) {
            throw new utils_1.RequiredError('email', 'Required parameter email was null or undefined when calling sendWelcomeByAccountId.');
        }
        // verify required parameter 'body' is not null or undefined
        if (params.body === null || params.body === undefined) {
            throw new utils_1.RequiredError('body', 'Required parameter body was null or undefined when calling sendWelcomeByAccountId.');
        }
        const path = `/accounts/{accountId}/welcome`
            .replace(`{${'accountId'}}`, String(params.accountId));
        const headers = {};
        const query = {};
        let body = null;
        if (params.email !== undefined) {
            query['email'] = params.email;
        }
        body = params.body || {};
        return this.serviceRequester.request({ method: 'POST', path, query, headers, body, options: params.options })
            .then(response => response.body);
    }
    /**
    * Send a welcome email to the user. Valid for ACCOUNT_ADMIN role or higher.
    * @summary Send a welcome email.
    * @param {string} accountId Account ID
    * @param {string} userId User ID
    * @param {UserWelcomeEmailRequest} body
    * @throws {RequiredError}
    */
    sendWelcomeToUserByAccountId(params) {
        // verify required parameter 'accountId' is not null or undefined
        if (params.accountId === null || params.accountId === undefined) {
            throw new utils_1.RequiredError('accountId', 'Required parameter accountId was null or undefined when calling sendWelcomeToUserByAccountId.');
        }
        // verify required parameter 'userId' is not null or undefined
        if (params.userId === null || params.userId === undefined) {
            throw new utils_1.RequiredError('userId', 'Required parameter userId was null or undefined when calling sendWelcomeToUserByAccountId.');
        }
        // verify required parameter 'body' is not null or undefined
        if (params.body === null || params.body === undefined) {
            throw new utils_1.RequiredError('body', 'Required parameter body was null or undefined when calling sendWelcomeToUserByAccountId.');
        }
        const path = `/accounts/{accountId}/users/{userId}/welcome`
            .replace(`{${'accountId'}}`, String(params.accountId))
            .replace(`{${'userId'}}`, String(params.userId));
        const headers = {};
        const query = {};
        let body = null;
        body = params.body || {};
        return this.serviceRequester.request({ method: 'POST', path, query, headers, body, options: params.options })
            .then(response => response.body);
    }
    /**
    * Update user with userId(email, userId or mobile number) if the token has role of `GLOBAL_ADMIN`, `PARTNER_ADMIN` or `ACCOUNT_ADMIN`.
    * @summary Update a User
    * @param {string} userId User ID
    * @param {UserPutRequest} body
    * @throws {RequiredError}
    */
    updateUser(params) {
        // verify required parameter 'userId' is not null or undefined
        if (params.userId === null || params.userId === undefined) {
            throw new utils_1.RequiredError('userId', 'Required parameter userId was null or undefined when calling updateUser.');
        }
        // verify required parameter 'body' is not null or undefined
        if (params.body === null || params.body === undefined) {
            throw new utils_1.RequiredError('body', 'Required parameter body was null or undefined when calling updateUser.');
        }
        const path = `/users/{userId}`
            .replace(`{${'userId'}}`, String(params.userId));
        const headers = {};
        const query = {};
        let body = null;
        body = params.body || {};
        return this.serviceRequester.request({ method: 'PUT', path, query, headers, body, options: params.options })
            .then(response => response.body);
    }
    /**
    * Update user with userId(email, userId or mobile number) if the token has role of `GLOBAL_ADMIN`, `PARTNER_ADMIN` or `ACCOUNT_ADMIN`.
    * @summary Update a User by Account
    * @param {string} accountId Account ID
    * @param {string} userId User ID
    * @param {UserPutRequest} body
    * @throws {RequiredError}
    */
    updateUserByAccountId(params) {
        // verify required parameter 'accountId' is not null or undefined
        if (params.accountId === null || params.accountId === undefined) {
            throw new utils_1.RequiredError('accountId', 'Required parameter accountId was null or undefined when calling updateUserByAccountId.');
        }
        // verify required parameter 'userId' is not null or undefined
        if (params.userId === null || params.userId === undefined) {
            throw new utils_1.RequiredError('userId', 'Required parameter userId was null or undefined when calling updateUserByAccountId.');
        }
        // verify required parameter 'body' is not null or undefined
        if (params.body === null || params.body === undefined) {
            throw new utils_1.RequiredError('body', 'Required parameter body was null or undefined when calling updateUserByAccountId.');
        }
        const path = `/accounts/{accountId}/users/{userId}`
            .replace(`{${'accountId'}}`, String(params.accountId))
            .replace(`{${'userId'}}`, String(params.userId));
        const headers = {};
        const query = {};
        let body = null;
        body = params.body || {};
        return this.serviceRequester.request({ method: 'PUT', path, query, headers, body, options: params.options })
            .then(response => response.body);
    }
    /**
    * Update tag with of a user with userId(email, userId or mobile number)   If the token has role of `USER` they will not be able to modify other users.
    * @summary Update a User tag
    * @param {string} userId User ID
    * @param {string} tagId Tag ID
    * @param {TagPutRequest} body
    * @throws {RequiredError}
    */
    updateUserTag(params) {
        // verify required parameter 'userId' is not null or undefined
        if (params.userId === null || params.userId === undefined) {
            throw new utils_1.RequiredError('userId', 'Required parameter userId was null or undefined when calling updateUserTag.');
        }
        // verify required parameter 'tagId' is not null or undefined
        if (params.tagId === null || params.tagId === undefined) {
            throw new utils_1.RequiredError('tagId', 'Required parameter tagId was null or undefined when calling updateUserTag.');
        }
        // verify required parameter 'body' is not null or undefined
        if (params.body === null || params.body === undefined) {
            throw new utils_1.RequiredError('body', 'Required parameter body was null or undefined when calling updateUserTag.');
        }
        const path = `/users/{userId}/tags/{tagId}`
            .replace(`{${'userId'}}`, String(params.userId))
            .replace(`{${'tagId'}}`, String(params.tagId));
        const headers = {};
        const query = {};
        let body = null;
        body = params.body || {};
        return this.serviceRequester.request({ method: 'PUT', path, query, headers, body, options: params.options })
            .then(response => response.body);
    }
    /**
    * Update tag with of a user with userId(email, userId or mobile number)   If the token has role of `USER` they will not be able to modify other users.
    * @summary Update a User tag by Account
    * @param {string} accountId Account ID
    * @param {string} userId User ID
    * @param {string} tagId Tag ID
    * @param {TagPutRequest} body
    * @throws {RequiredError}
    */
    updateUserTagByAccountId(params) {
        // verify required parameter 'accountId' is not null or undefined
        if (params.accountId === null || params.accountId === undefined) {
            throw new utils_1.RequiredError('accountId', 'Required parameter accountId was null or undefined when calling updateUserTagByAccountId.');
        }
        // verify required parameter 'userId' is not null or undefined
        if (params.userId === null || params.userId === undefined) {
            throw new utils_1.RequiredError('userId', 'Required parameter userId was null or undefined when calling updateUserTagByAccountId.');
        }
        // verify required parameter 'tagId' is not null or undefined
        if (params.tagId === null || params.tagId === undefined) {
            throw new utils_1.RequiredError('tagId', 'Required parameter tagId was null or undefined when calling updateUserTagByAccountId.');
        }
        // verify required parameter 'body' is not null or undefined
        if (params.body === null || params.body === undefined) {
            throw new utils_1.RequiredError('body', 'Required parameter body was null or undefined when calling updateUserTagByAccountId.');
        }
        const path = `/accounts/{accountId}/users/{userId}/tags/{tagId}`
            .replace(`{${'accountId'}}`, String(params.accountId))
            .replace(`{${'userId'}}`, String(params.userId))
            .replace(`{${'tagId'}}`, String(params.tagId));
        const headers = {};
        const query = {};
        let body = null;
        body = params.body || {};
        return this.serviceRequester.request({ method: 'PUT', path, query, headers, body, options: params.options })
            .then(response => response.body);
    }
    /**
    * Determines if a verified user exists with the given userId.  This request is only supported for certain clients.
    * @summary Check if a verified user exists
    * @param {string} userId User ID
    * @param {string} [accountId] Account ID
    * @param {string} [clientId] Client ID
    * @throws {RequiredError}
    */
    userExists(params) {
        // verify required parameter 'userId' is not null or undefined
        if (params.userId === null || params.userId === undefined) {
            throw new utils_1.RequiredError('userId', 'Required parameter userId was null or undefined when calling userExists.');
        }
        const path = `/users/{userId}`
            .replace(`{${'userId'}}`, String(params.userId));
        const headers = {};
        const query = {};
        let body = null;
        if (params.accountId !== undefined) {
            query['accountId'] = params.accountId;
        }
        if (params.clientId !== undefined) {
            query['clientId'] = params.clientId;
        }
        return this.serviceRequester.request({ method: 'HEAD', path, query, headers, body, options: params.options })
            .then(response => response.body);
    }
    /**
    * Verifies the communication method if the temporary Access Code matches.
    * @summary Verifies AccessCode
    * @param {string} userId User ID
    * @param {UserAccessCodePutRequest} body
    * @throws {RequiredError}
    */
    verifyUserAccessCode(params) {
        // verify required parameter 'userId' is not null or undefined
        if (params.userId === null || params.userId === undefined) {
            throw new utils_1.RequiredError('userId', 'Required parameter userId was null or undefined when calling verifyUserAccessCode.');
        }
        // verify required parameter 'body' is not null or undefined
        if (params.body === null || params.body === undefined) {
            throw new utils_1.RequiredError('body', 'Required parameter body was null or undefined when calling verifyUserAccessCode.');
        }
        const path = `/users/{userId}/accessCode`
            .replace(`{${'userId'}}`, String(params.userId));
        const headers = {};
        const query = {};
        let body = null;
        body = params.body || {};
        return this.serviceRequester.request({ method: 'PUT', path, query, headers, body, options: params.options })
            .then(response => response.body);
    }
    /**
    * Handle notifications from platform-api-notifications
    * @summary PBX notifications
    * @param {Notification} body
    * @throws {RequiredError}
    */
    handePbxWebhook(params) {
        // verify required parameter 'body' is not null or undefined
        if (params.body === null || params.body === undefined) {
            throw new utils_1.RequiredError('body', 'Required parameter body was null or undefined when calling handePbxWebhook.');
        }
        const path = `/webhooks/notifications/pbx`;
        const headers = {};
        const query = {};
        let body = null;
        body = params.body || {};
        return this.serviceRequester.request({ method: 'POST', path, query, headers, body, options: params.options })
            .then(response => response.body);
    }
}
exports.AdminService = AdminService;
